const html = `<!-- https://freesound.org/people/deleted_user_2731495/sounds/183881/ -->
<audio id="introSong" src="assets/sounds/menu.ogg" loop></audio>




<a-scene
  bind__beat-generator="challengeId: challenge.id; difficulty: challenge.difficulty; beatmapCharacteristic: challenge.beatmapCharacteristic; gameMode: gameMode; has3DOFVR: has3DOFVR; hasSongLoadError: hasSongLoadError; isPlaying: isPlaying; isZipFetching: isZipFetching; menuSelectedChallengeId: menuSelectedChallenge.id; songDuration: challenge.metadata.duration; speed: speed"
  bind__beat-system="gameMode: gameMode; hasVR: hasVR; isLoading: isLoading; isPlaying: isPlaying"
  bind__gameover="isGameOver: isGameOver"
  bind__intro-song="isPlaying: menuActive && !menuSelectedChallenge.id; isSearching: isSearching"
  bind__leaderboard="difficulty: menuSelectedChallenge.difficulty || challenge.difficulty; beatmapCharacteristic: menuSelectedChallenge.beatmapCharacteristic || challenge.beatmapCharacteristic; gameMode: gameMode; inVR: inVR; isVictory: isVictory; menuSelectedChallengeId: menuSelectedChallenge.id; challengeId: challenge.id"
  bind__search="difficultyFilter: difficultyFilter; genre: genre; playlist: playlist; query: search.query"
  bind__song="audio: challenge.audio; challengeId: challenge.id; isLoading: isLoading; isPlaying: isPlaying; isBeatsPreloaded: challenge.isBeatsPreloaded; isGameOver: isGameOver; isVictory: isVictory"
  bind__song-preview-system="selectedChallengeId: menuSelectedChallenge.id; selectedChallengeVersion: menuSelectedChallenge.version"
  bind__stage-colors="colorScheme: colorScheme"
  bind__tunnels="isPlaying: isPlaying; songDuration: challenge.metadata.duration"
  bind__zip-loader="difficulties: menuDifficulties; isLoading: isLoading; version: menuSelectedChallenge.version; directDownload: menuSelectedChallenge.directDownload; bpm: menuSelectedChallenge.metadata.bpm"
  animation__gameover="property: object3D.background; type: color; to: #750000; startEvents: gameover"
  console-shortcuts
  debug-beat-generator
  debug-beat-positioning
  debug-controller
  debug-intro
  debug-song-time
  debug-state
  hack
  gpu-preloader
  
  leaderboard="apiKey: AIzaSyAilakXLvMgwPcBcHs3oys51eLp4yrfz0w; authDomain: moonrider-prod.firebaseapp.com; databaseURL: https://moonrider-prod.firebaseio.com; projectId: moonrider-prod; storageBucket: moonrider-prod.appspot.com; messagingSenderId: 172125624222"
  loading-screen="backgroundColor: #000"
  pool__beat-arrow-blue="mixin: arrowBlueBeat; size: 30; container: #beatContainer; dynamic: true"
  pool__beat-arrow-red="mixin: arrowRedBeat; size: 30; container: #beatContainer; dynamic: true"
  pool__beat-dot-blue="mixin: dotBlueBeat; size: 30; container: #beatContainer; dynamic: true"
  pool__beat-dot-red="mixin: dotRedBeat; size: 30; container: #beatContainer; dynamic: true"
  pool__beat-mine="mixin: mine; size: 30; container: #beatContainer"
  pool__plume-arrow-blue="mixin: arrowBluePlume; size: 30; container: #beatContainer; dynamic: true"
  pool__plume-arrow-red="mixin: arrowRedPlume; size: 30; container: #beatContainer; dynamic: true"
  pool__plume-dot-blue="mixin: dotBluePlume; size: 30; container: #beatContainer; dynamic: true"
  pool__plume-dot-red="mixin: dotRedPlume; size: 30; container: #beatContainer; dynamic: true"
  pool__plume-mine="mixin: minePlume; size: 12; container: #beatContainer; dynamic: true"
  pool__beat-broken-blue="mixin: blueBeatBroken; size: 10; container: #rigContainer; dynamic: true"
  pool__beat-broken-red="mixin: redBeatBroken; size: 10; container: #rigContainer; dynamic: true"
  pool__beat-broken-blue-dot="mixin: blueDotBroken; size: 10; container: #rigContainer; dynamic: true"
  pool__beat-broken-red-dot="mixin: redDotBroken; size: 10; container: #rigContainer; dynamic: true"
  pool__punch-broken-blue-dot="mixin: blueDotPunchBroken; size: 10; container: #rigContainer; dynamic: true"
  pool__punch-broken-red-dot="mixin: redDotPunchBroken; size: 10; container: #rigContainer; dynamic: true"
  pool__beat-broken-mine="mixin: mineBroken; size: 10; container: #rigContainer; dynamic: true"
  pool__beat-fx-blue="mixin: blueBeatFX; size: 10; container: #rigContainer; dynamic: true"
  pool__beat-fx-red="mixin: redBeatFX; size: 10; container: #rigContainer; dynamic: true"
  pool__beat-fx-mine="mixin: mineFX; size: 12; container: #rigContainer; dynamic: true"
  pool__punch-fx-blue="mixin: bluePunchFX; size: 10; container: #rigContainer; dynamic: true"
  pool__punch-fx-red="mixin: redPunchFX; size: 10; container: #rigContainer; dynamic: true"
  pool__punch-fx-mine="mixin: yellowPunchFX; size: 12; container: #rigContainer; dynamic: true"
  pool__tunnels="mixin: tunnel; size: 10; container: #tunnelsContainer; dynamic: true"
  pool__wall="mixin: wall; size: 20; container: #wallContainer; dynamic: true"
  proxy-event__cleargame1="event: gamemenuexit; as: cleargame; to: a-scene"
  proxy-event__cleargame2="event: gamemenurestart; as: cleargame; to: a-scene"
  proxy-event__cleargame3="event: songcomplete; as: cleargame; to: a-scene"
  proxy-event__pausegame="event: pausegame; as: textglowoff; to: a-scene"
  proxy-event__resumegame="event: gamemenuresume; as: textglownormal; to: a-scene"
  play-sound__crescendo="sound: #crescendo; event: victory; volume: 0.75"
  render-order="stage, aurora, sideglow, tunnel, curve, curveshadow, beatShadow, score, beats, menu, menuitem, menubutton, menutext, menugenre, cursor, particles, weapon, victory, stepback"
  stats-param
  tunnels
  vr-mode-ui="enterVRButton: #vrButton">

  <a-assets timeout="3000">
    <!-- <require path="/home/lpv/repos/moonrider/src/assets.html"> -->
<a-asset-item id="VigaRegularThree" src="assets/fonts/Viga-Regular-Three.json"></a-asset-item>

<a-asset-item id="arrowredObj" src="assets/models/arrowred.obj"></a-asset-item>
<a-asset-item id="arrowblueObj" src="assets/models/arrowblue.obj"></a-asset-item>
<a-asset-item id="beatObj" src="assets/models/beat.obj"></a-asset-item>
<a-asset-item id="laserObj" src="assets/models/laser/laser.obj"></a-asset-item>

<a-asset-item id="tunnelObj" src="assets/models/tunnel.obj"></a-asset-item>
<a-asset-item id="redBeatObj" src="assets/models/redbeat.obj"></a-asset-item>
<a-asset-item id="blueBeatObj" src="assets/models/bluebeat.obj"></a-asset-item>
<a-asset-item id="dotRedObj" src="assets/models/dotred.obj"></a-asset-item>
<a-asset-item id="dotBlueObj" src="assets/models/dotblue.obj"></a-asset-item>
<a-asset-item id="backGlowObj" src="assets/models/backglow.obj"></a-asset-item>
<a-asset-item id="aurorasObj" src="assets/models/auroras.obj"></a-asset-item>
<a-asset-item id="merkabaObj" src="assets/models/merkaba.obj"></a-asset-item>
<a-asset-item id="ringsObj" src="assets/models/rings.obj"></a-asset-item>
<a-asset-item id="homeObj" src="assets/models/home.obj"></a-asset-item>
<a-asset-item id="homeShadowObj" src="assets/models/homeshadow.obj"></a-asset-item>
<a-asset-item id="weaponObj" src="assets/models/weapon.obj"></a-asset-item>
<a-asset-item id="weaponHandleObj" src="assets/models/weaponhandle.obj"></a-asset-item>
<a-asset-item id="weaponGlowObj" src="assets/models/weaponglow.obj"></a-asset-item>
<a-asset-item id="beatBrokenObj" src="assets/models/beatbroken.obj"></a-asset-item>
<a-asset-item id="dotBrokenObj" src="assets/models/dotbroken.obj"></a-asset-item>
<a-asset-item id="dotPunchBrokenObj" src="assets/models/dotbroken.gltf"></a-asset-item>
<a-asset-item id="cutfxObj" src="assets/models/cutfx.obj"></a-asset-item>
<a-asset-item id="punchfxObj" src="assets/models/punchfx.obj"></a-asset-item>
<a-asset-item id="leftFistObj" src="assets/models/leftfist.obj"></a-asset-item>
<a-asset-item id="leftFistWeaponObj" src="assets/models/leftfistweapon.obj"></a-asset-item>
<a-asset-item id="rightFistObj" src="assets/models/rightfist.obj"></a-asset-item>
<a-asset-item id="rightFistWeaponObj" src="assets/models/rightfistweapon.obj"></a-asset-item>
<a-asset-item id="plumeObj" src="assets/models/plume.obj"></a-asset-item>

<a-asset-item id="mineObj" src="assets/models/mine.obj"></a-asset-item>
<a-asset-item id="mineBrokenObj" src="assets/models/minebroken.gltf"></a-asset-item>

<!--
 https://freesound.org/people/juskiddink/sounds/70043/
 https://freesound.org/people/Robinhood76/sounds/337436/
-->
<audio id="confirmSound" src="assets/sounds/beatHit.ogg"></audio>
<audio id="clearSound" src="assets/sounds/clear.ogg"></audio>
<audio id="hoverSound" src="assets/sounds/hover.ogg"></audio>
<audio id="victorySound" src="assets/sounds/victory.ogg"></audio>
<audio id="crescendo" src="assets/sounds/crescendo.ogg"></audio>


<audio id="hitSound1" src="assets/sounds/hit1.ogg"></audio>
<audio id="hitSound1left" src="assets/sounds/hit1left.ogg"></audio>
<audio id="hitSound1right" src="assets/sounds/hit1right.ogg"></audio>

<audio id="hitSound2" src="assets/sounds/hit2.ogg"></audio>
<audio id="hitSound2left" src="assets/sounds/hit2left.ogg"></audio>
<audio id="hitSound2right" src="assets/sounds/hit2right.ogg"></audio>

<audio id="hitSound3" src="assets/sounds/hit3.ogg"></audio>
<audio id="hitSound3left" src="assets/sounds/hit3left.ogg"></audio>
<audio id="hitSound3right" src="assets/sounds/hit3right.ogg"></audio>

<audio id="hitSound4" src="assets/sounds/hit4.ogg"></audio>
<audio id="hitSound4left" src="assets/sounds/hit4left.ogg"></audio>
<audio id="hitSound4right" src="assets/sounds/hit4right.ogg"></audio>

<audio id="hitSound5" src="assets/sounds/hit5.ogg"></audio>
<audio id="hitSound5left" src="assets/sounds/hit5left.ogg"></audio>
<audio id="hitSound5right" src="assets/sounds/hit5right.ogg"></audio>

<audio id="hitSound6" src="assets/sounds/hit6.ogg"></audio>
<audio id="hitSound6left" src="assets/sounds/hit6left.ogg"></audio>
<audio id="hitSound6right" src="assets/sounds/hit6right.ogg"></audio>

<audio id="hitSound7" src="assets/sounds/hit7.ogg"></audio>
<audio id="hitSound7left" src="assets/sounds/hit7left.ogg"></audio>
<audio id="hitSound7right" src="assets/sounds/hit7right.ogg"></audio>

<audio id="hitSound8" src="assets/sounds/hit8.ogg"></audio>
<audio id="hitSound8left" src="assets/sounds/hit8left.ogg"></audio>
<audio id="hitSound8right" src="assets/sounds/hit8right.ogg"></audio>

<audio id="hitSound9" src="assets/sounds/hit9.ogg"></audio>
<audio id="hitSound9left" src="assets/sounds/hit9left.ogg"></audio>
<audio id="hitSound9right" src="assets/sounds/hit9right.ogg"></audio>

<audio id="hitSound10" src="assets/sounds/hit10.ogg"></audio>
<audio id="hitSound10left" src="assets/sounds/hit10left.ogg"></audio>
<audio id="hitSound10right" src="assets/sounds/hit10right.ogg"></audio>


<img id="cursorMeshImg" src="assets/models/laser/laser.png">
<img id="downIconImg" src="assets/img/downIcon.png">
<img id="envmapTemplateImg" src="assets/img/envmap.png">
<img id="envmapImg">
<img id="favoriteImg" src="assets/img/favorite.png">
<img id="sliceImg" src="assets/img/slice.png">
<img id="stepbackImg" src="assets/img/stepback.png">
<img id="soundboxingImg" src="assets/img/soundboxing.jpg">
<img id="genresImg" src="assets/img/genres.png">
<img id="starImg" src="assets/img/star.png">
<img id="merkabaBloomImg" src="assets/img/merkababloom.png">
<img id="homeShadowImg" src="assets/img/homeshadow.jpg">
<img id="backGlowImg" src="assets/img/backglow.png">
<img id="weaponImg" src="assets/img/weapon.jpg">
<img id="weapon2Img" src="assets/img/weapon2.jpg">
<img id="weaponHandleImg" src="assets/img/weaponhandle.png">
<img id="difficultyImg" src="assets/img/difficulty.png">
<img id="selectedImg" src="assets/img/selected.png">
<img id="cutfxImg" src="assets/img/cutfx.png">
<!--
<img id="cutFxTemplateImg" src="assets/img/cutfx.png">
<img id="cutFxImg">
-->
<img id="minefxImg" src="assets/img/minefx.png">
<img id="sideglowImg" src="assets/img/sideglow.png">
<img id="logoImg" src="assets/img/logo.png">
<img id="moonImg" src="assets/img/moon.png">
<img id="plumeImg" src="assets/img/plume.png">
<img id="tubeImg" src="assets/img/tube.png">
<img id="tubeColorImg" src="assets/img/tube.jpg">
<img id="handStarTrailImg" src="assets/img/handstartrail.png">

<img id="modeRideImg" src="assets/img/moderide.jpg">
<img id="modeClassicImg" src="assets/img/modeclassic.jpg">
<img id="modePunchImg" src="assets/img/modepunch.jpg">
<img id="modeViewerImg" src="assets/img/modeviewer.jpg">

<a-mixin id="slice" slice9="color: #050505; transparent: true; opacity: 0.9; src: #sliceImg; left: 50; right: 52; top: 50; bottom: 52; padding: 0.18"></a-mixin>
<a-mixin id="font" text="font: assets/fonts/Viga-Regular.json; shader: msdf; letterSpacing: 1"></a-mixin>

<a-mixin id="superKeyboardTextInput" mixin="font"></a-mixin>

<a-mixin id="beat"></a-mixin>
<a-mixin id="beatBlock"></a-mixin>
<a-mixin id="beatSign"></a-mixin>

<a-mixin id="arrowBlueBeat" mixin="beat" beat="color: blue; type: arrow"></a-mixin>
<a-mixin id="arrowRedBeat" mixin="beat" beat="color: red; type: arrow"></a-mixin>
<a-mixin id="dotBlueBeat" mixin="beat" beat="color: blue; type: dot"></a-mixin>
<a-mixin id="dotRedBeat" mixin="beat" beat="color: red; type: dot"></a-mixin>
<a-mixin id="mine" mixin="beat" beat="type: mine"></a-mixin>
<a-mixin id="beatShadow" mixin="beat" geometry="primitive: plane; width: 0.7; height: 0.6" rotation="-90 0 0" material="src: #minefxImg; shader: flat; color: #000; transparent: true; opacity: 0.2" render-order="beatShadow"></a-mixin>

<a-mixin id="plume" plume obj-model="obj: #plumeObj"></a-mixin>
<a-mixin id="arrowBluePlume" mixin="plume" plume="type: arrow; color: blue" materials="name: arrowBluePlume"></a-mixin>
<a-mixin id="arrowRedPlume" mixin="plume" plume="type: arrow; color: red" materials="name: arrowRedPlume"></a-mixin>
<a-mixin id="dotBluePlume" mixin="plume" plume="type: dot; color: blue" materials="name: dotBluePlume"></a-mixin>
<a-mixin id="dotRedPlume" mixin="plume" plume="type: dot; color: red" materials="name: dotRedPlume"></a-mixin>
<a-mixin id="minePlume" mixin="plume" plume="type: mine" materials="name: minePlume"></a-mixin>

<a-mixin
  id="superCut"
  bind__supercutfx="colorPrimary: colorPrimary; colorSecondary: colorSecondary"
  supercutfx
  geometry="primitive: plane; width: 3; height: 3"
  material="shader: superCutFxShader; transparent: true; depthWrite: false"></a-mixin>

<a-mixin
  id="redBeatBroken"
  obj-model="obj: #beatBrokenObj"
  beat-cut-fx="color: red"
  render-order="beats"></a-mixin>
<a-mixin
  id="blueBeatBroken"
  obj-model="obj: #beatBrokenObj"
  beat-cut-fx="color: blue"
  render-order="beats"></a-mixin>
<a-mixin
  id="redDotBroken"
  obj-model="obj: #dotBrokenObj"
  beat-cut-fx="color: red; type: dot"
  render-order="beats"></a-mixin>
<a-mixin
  id="blueDotBroken"
  obj-model="obj: #dotBrokenObj"
  beat-cut-fx="color: blue; type: dot"
  render-order="beats"></a-mixin>

<a-mixin
  id="redDotPunchBroken"
  gltf-model="#dotPunchBrokenObj"
  beat-cut-fx="color: red; type: dot"
  render-order="beats"></a-mixin>
<a-mixin
  id="blueDotPunchBroken"
  gltf-model="#dotPunchBrokenObj"
  beat-cut-fx="color: blue; type: dot"
  render-order="beats"></a-mixin>

<a-mixin
  id="redBeatFX"
  bind__material="color: colorPrimary"
  obj-model="obj: #cutfxObj"
  material="shader: cutfxShader; progress: 1"
  render-order="menu"
  animation="property: components.material.material.uniforms.progress.value; from: 0; to: 1; dur: 400; loop: false; easing: linear; startEvents: explode"></a-mixin>

<a-mixin
  id="blueBeatFX"
  bind__material="color: colorSecondary"
  obj-model="obj: #cutfxObj"
  material="shader: cutfxShader; progress: 1"
  render-order="menu"
  animation="property: components.material.material.uniforms.progress.value; from: 0; to: 1; dur: 400; loop: false; easing: linear; startEvents: explode"></a-mixin>

<a-mixin
  id="mineBroken"
  gltf-model="#mineBrokenObj"
  beat-cut-fx="type: mine"
  render-order="beats"></a-mixin>

<a-mixin
  id="mineFX"
  geometry="primitive: plane; width: 0.6; height: 0.6"
  material="shader: flat; transparent: true; src: #minefxImg; color: #fff568; depthWrite: false"
  render-order="menu"
  animation="property: components.material.material.opacity; from:1; to:0; dur: 400; loop: false; easing: linear; startEvents: explode"></a-mixin>

<a-mixin
  id="redPunchFX"
  bind__material="color: colorPrimary"
  obj-model="obj: #punchfxObj"
  material="shader: cutfxShader; progress: 1"
  render-order="menu"
  animation="property: components.material.material.uniforms.progress.value; from: 0; to: 1; dur: 600; loop: false; easing: linear; startEvents: explode"></a-mixin>

<a-mixin
  id="bluePunchFX"
  bind__material="color: colorSecondary"
  obj-model="obj: #punchfxObj"
  material="shader: cutfxShader; progress: 1"
  render-order="menu"
  animation="property: components.material.material.uniforms.progress.value; from: 0; to: 1; dur: 600; loop: false; easing: linear; startEvents: explode"></a-mixin>

<a-mixin
  bind__material="color: colorTertiary"
  id="yellowPunchFX"
  obj-model="obj: #punchfxObj"
  material="shader: cutfxShader; progress: 1"
  render-order="menu"
  animation="property: components.material.material.uniforms.progress.value; from: 0; to: 1; dur: 600; loop: false; easing: linear; startEvents: explode"></a-mixin>

<a-mixin
  id="wall"
  material="shader: wallShader; transparent: true; side: double; opacity: 0"
  animation__fadein="property: components.material.material.uniforms.opacity.value; from: 0; to: 1; easing: easeInCubic; autoplay: false; dur: 1500"
  animation__scalein="property: object3D.position.y; from: -5; to: 0; easing: easeInOutElastic; autoplay: false; dur: 1500"
  render-order
  wall></a-mixin>

<a-mixin
  id="tunnel"
  obj-model="obj: #tunnelObj"
  materials="name: tunnel"></a-mixin>

<a-mixin
  id="bigMenuButton"
  geometry="primitive: plane; width: 1.15; height: 0.23"
  material="shader: panelShader; brightness: 0.5; borderWidth: 0.05; ratio: 4; borderRadius: 0.6"
  animation__mouseenter1="property: components.material.material.uniforms.activePanel.value; from: 0; to: 1; startEvents: mouseenter; pauseEvents: mouseleave; dur: 100"
  animation__mouseleave1="property: components.material.material.uniforms.activePanel.value; from: 1; to: 0; startEvents: mouseleave; pauseEvents: mouseenter; dur: 100"
  animation__mouseenter2="property: scale; from: 1 1 1; to: 1.04 1.04 1.04; startEvents: mouseenter; pauseEvents: mouseleave; dur: 80"
  animation__mouseleave2="property: scale; to: 1 1 1; from: 1.04 1.04 1.04; startEvents: mouseleave; pauseEvents: mouseenter; dur: 80"
  render-order="menubutton"></a-mixin>

<a-mixin id="cancelSoundUI" play-sound__cancel="event: click; sound: #clearSound; volume: 0.5"></a-mixin>
<a-mixin id="clickSoundUI" play-sound__click="event: click; sound: #confirmSound; volume: 0.25"></a-mixin>
<a-mixin id="hoverSoundUI" play-sound__hover="event: mouseenter; sound: #hoverSound; volume: 0.1"></a-mixin>
<!-- </require> --></require>
  </a-assets>

  <a-entity id="beatObjTemplate" obj-model="obj: #beatObj" visible="false"></a-entity>
  <a-entity id="redBeatObjTemplate" obj-model="obj: #redBeatObj" visible="false"></a-entity>
  <a-entity id="blueBeatObjTemplate" obj-model="obj: #blueBeatObj" visible="false"></a-entity>
  <a-entity id="dotRedObjTemplate" obj-model="obj: #dotRedObj" visible="false"></a-entity>
  <a-entity id="dotBlueObjTemplate" obj-model="obj: #dotBlueObj" visible="false"></a-entity>
  <a-entity id="mineObjTemplate" obj-model="obj: #mineObj" visible="false"></a-entity>
  <a-entity id="cursorLaser" obj-model="obj: #laserObj" visible="false"></a-entity>

  <!-- <require path="/home/lpv/repos/moonrider/src/templates/loading.html"> -->
<a-entity
  id="loadingSongInfoContainer"
  bind__animation__scale="enabled: isLoading"
  bind__visible="isLoading"
  animation__scale="property: scale; from: 1 1 1; to: 1.05 1.05 1.05; dir: alternate; loop: true; dur: 1200; easing: easeInOutCubic"
  position="0 1.5 -2">

  <a-entity
    id="loadingMenuBackground"
    bind-toggle__raycastable="isLoading"
    render-order="menu"
    geometry="primitive: plane; width: 1.15; height: 1.2"
    material="shader: panelShader; ratio: 1.15; borderRadius: 0.4"
    position="0 0 -0.03"></a-entity>

  <a-entity id="loadingSongImage"
    copy-texture="from: #menuSelectedChallengeImage"
    geometry="primitive: plane; buffer: false; skipCache: true; height: 0.3; width: 0.3"
    material="shader: flat; transparent: false"
    position="0 0.24 0"
    render-order="menu"></a-entity>

  <a-entity id="loadingSongInfo">
    <a-entity
      position="0 -0.05 0"
      mixin="font"
      bind__text="color: colorSecondary"
      bind__text-truncate="value: challenge.songSubName + ' - ' + challenge.author"
      text="wrapCount: 40; align: center"
      text-truncate="length: 35"
      render-order="menutext"></a-entity>

    <a-entity position="0 -0.13 0"
      mixin="font"
      text="align: center; color: #FFF; wrapCount: 21; baseline: top; lineHeight: 36; width: 0.81"
      bind__text="value: challenge.metadata.songName"
      render-order="menutext"></a-entity>

    <a-entity
      id="loadingText"
      mixin="font"
      bind__animation__color="enabled: isLoading"
      bind__text="color: colorPrimary; value: loadingText; wrapCount: hasSongLoadError && 24 || 18"
      bind__visible="isLoading"
      text="align: center; wrapCount: 18; width: 0.65"
      render-order="menutext"
      position="0 -0.32 0.001"></a-entity>

    <a-entity
      id="zipLoaderIndicator"
      bind__material="color: colorPrimary"
      bind__visible="isZipFetching"
      geometry="primitive: plane; height: 0.1; width: 0.1"
      material="shader: ring; radiusInner: 0.2; radiusOuter: 0.9; progress: 0; transparent: true"
      render-order="menuitem"
      position="0 -0.4 0.002">
    </a-entity>

    <a-entity
      id="songProcessingIndicator"
      bind__animation__spin="enabled: isSongProcessing"
      bind__material="color: colorPrimary"
      bind__visible="isSongProcessing"
      animation__spin="property: object3D.rotation.z; from: 0; to: -360; easing: linear; dur: 1000; loop: true"
      geometry="primitive: plane; height: 0.15; width: 0.15"
      material="shader: ring; radiusInner: 0.2; radiusOuter: 0.4; transparent: true; progress: 0.2"
      render-order="menutext"
      position="0 -0.4 0.004"
      visible="false">
    </a-entity>

    <a-entity
      id="loadingCancelButton"
      mixin="bigMenuButton"
      bind-toggle__raycastable="isLoading"
      position="0 -0.67 0.01"
      proxy-event="event: click; to: a-scene; as: songloadcancel">
      <a-entity mixin="font" text="align: center; color: #FAFAFA; wrapCount: 20; value: CANCEL" position="0 -0.065 0.001"></a-entity>
    </a-entity>
  </a-entity>
</a-entity>
<!-- </require> --></require>
  <!-- <require path="/home/lpv/repos/moonrider/src/templates/stage.html"> -->
<a-entity
  id="audioAnalyser"
  audioanalyser="fftSize: 32; enableBeatDetection: false; enableLevels: false; enableWaveform: false; enableVolume: false"></a-entity>

<a-entity id="stage" no-frustum-cull follow-z="target: #curveFollowRig">
  <a-entity
    id="backglow"
    obj-model="obj: #backGlowObj"
    materials="name: backglow"
    render-order="stage"></a-entity>

  <a-entity
    id="rings"
    obj-model="obj: #ringsObj"
    materials="name: rings"
    position="0 0 -1500"
    render-order="stage"></a-entity>

  <a-entity
    id="auroras"
    class="aurora"
    obj-model="obj: #aurorasObj"
    materials="name: aurora"
    render-order="aurora"></a-entity>

  <a-entity
    id="merkaba"
    obj-model="obj: #merkabaObj"
    bind__visible="!isVictory && !isGameOver"
    materials="name: merkaba"
    animation="property: rotation; from: 0 0 0; to: 360 360 360; dur: 50000; easing: linear; loop: true"
    position="0 46 -1500"></a-entity>

  <a-entity
    class="merkababloom"
    geometry="primitive: plane; width: 200; height: 200"
    material="shader: flat; src: #merkabaBloomImg; blending: additive; depthTest: false; color: #888"
    position="0 46 -1400"
    render-order="stage"></a-entity>

  <a-entity
    class="merkababloom"
    bind__material="color: colorTertiary"
    geometry="primitive: plane; width: 250; height: 250"
    animation="property: object3D.rotation.z; from: 0; to: 360; loop: true; easing: linear; dur: 30000"
    material="shader: flat; src: #merkabaBloomImg; blending: additive; depthTest: false"
    position="0 46 -1380"
    render-order="stage"></a-entity>

  <a-entity
    id="moon"
    geometry="primitive: plane; width: 1000; height: 500"
    position="0 1000 -1000"
    rotation="45 0 0"
    materials="name: moon"
    ></a-entity>

  <a-entity class="stars" stars render-order="particles"></a-entity>

  <!-- <require path="/home/lpv/repos/moonrider/src/templates/intro.html"> -->
<a-entity
  id="mainLogo"
  geometry="primitive: plane; width: 9; height: 1.125"
  material="shader: flat; src: #logoImg; transparent: true; depthTest: false; blending: additive; opacity: 0"
  position="0 3.3 -2.5"
  rotation="0 0 0"
  scale="0.8 0.8 0.8"
  bind__visible="introActive || menuActive"
  animation__opacity="property: components.material.material.opacity; from: 0; to: 1; dur: 2000; delay: 1000"
  animation__position="property: object3D.position.y; to: 3.4; dur: 2000; easing: easeInOutQuad; startEvents: startgame"></a-entity>

<a-entity
  id="startButton"
  bind__visible-raycastable="introActive"
  geometry="primitive: plane; width: 1; height: 0.35"
  position="0 1.6 -2.2"
  render-order="menu"
  proxy-event="event: click; to: a-scene, #menu, #mainlogo, #menuTopButtons, #menuBackground; as: startgame"
  delayed-proxy-event="event: click; to: a-scene; as: menuopeningend; delay: 1800"
  mixin="bigMenuButton"
  play-sound__hover="event: mouseenter; sound: #hoverSound; volume: 0.1"
  play-sound__click="event: click; sound: #confirmSound;  volume: 0.25"
  material="ratio: 3; opacity: 0"
  animation="property: components.material.material.uniforms.opacity.value; from: 0; to: 1; dur: 500; delay: 3000">
  <a-entity
    id="startButtonLabel"
    mixin="font"
    text="value: BEGIN; color: #f0f0f0; align: center; width: 1; wrapCount: 12; opacity: 0"
    position="0 -0.1 0.01"
    animation="property: components.text.material.uniforms.opacity.value; from: 0; to: 1; dur: 500; delay: 3500"
    ></a-entity>
</a-entity>
<!-- </require> --></require>
</a-entity>
<!-- </require> --></require>
  <!-- <require path="/home/lpv/repos/moonrider/src/templates/menu.html"> -->
<!-- Macro is a templating function. It is rendered into the HTML below with searchResults(). -->



<template id="searchResultTemplate">
  <a-entity class="searchResult" bind-item__data-id="item.id" bind-item__data-index="item.index">
    <a-entity class="searchResultBackground" bind-item__active-item="active: menuSelectedChallenge.id === item.id"
      bind-item__animation__mouseenter="enabled: menuSelectedChallenge.id !== item.id"
      bind-item__animation__mouseleave="enabled: menuSelectedChallenge.id !== item.id"
      bind-toggle__raycastable="mainMenuActive || isSearching" bind__material="color: colorPrimary"
      animation__mouseenter="property: components.material.material.opacity; to: 0.4; startEvents: mouseenter; pauseEvents: mouseleave; dur: 75; delay: 1"
      animation__mouseleave="property: components.material.material.opacity; to: 0.0; startEvents: mouseleave; pauseEvents: mouseenter; dur: 75"
      geometry="primitive: plane; width: 1.1; height: 0.2"
      material="shader: flat; transparent: true; opacity: 0.0; src: #selectedImg" position="0 -0.13 -0.002"
      play-sound="event: mouseenter; sound: #hoverSound; volume: 0.03" render-order="menuitem"></a-entity>
  </a-entity>
  </a-entity>
</template>


<!-- Menu container begins here. -->
<a-entity id="menu" bind__visible="menuActive" position="0 1.4 -2.3"
  animation__position="property: object3D.position.z; to: -2; dur: 1500; easing: easeInOutCubic; delay: 300; startEvents: startgame">

  <a-entity id="menuBackground"
    bind__menu-midsection="active: !!menuSelectedChallenge.id && (mainMenuActive || difficultyFilterMenuOpen) || difficultyFilterMenuOpen; selectedChallenge: menuSelectedChallenge.id"
    bind-toggle__raycastable="menuActive || genreMenuOpen || isSearching || difficultyFilterMenuOpen"
    geometry="primitive: plane; width: 3.4; height: 1.82" material="shader: panelShader; ratio: 1.86; opacity: 0"
    animation__opacity="property: components.material.material.uniforms.opacity.value; from: 0; to: 1; dur: 1000; delay: 300; startEvents: startgame"
    animation__midsectionshow="property: components.material.material.uniforms.midSection.value; from: 0; to: 1; dur: 160; startEvents: showdifficultysection; easing: easeOutCubic"
    animation__midsectionhide="property: components.material.material.uniforms.midSection.value; from: 1: to: 0; dur: 160; startEvents: hidedifficultysection; easing: easeOutCubic"
    render-order="menu" position="0 0 -0.005"></a-entity>

  <a-entity id="mainMenu" bind__visible="mainMenuActive && !isMenuOpening || isSearching">
    <a-entity id="searchResultsContainer" position="0 0 0.001" class="menuAnimation"
      bind__menu-slide-animation="isSearching: isSearching; menuSelectedChallengeId: menuSelectedChallenge.id"
      animation__menuleft="property: object3D.position.x; to: -0.79; dur: 200; easing: easeOutCubic; autoplay: false"
      animation__menuright="property: object3D.position.x; from: -0.79; to: 0; dur: 200; easing: easeOutCubic; autoplay: false">

      
<!-- TODO: Sort the layout based on the IDs. -->
<a-entity id="searchResultList"
  bind-for="for: item; in: searchResultsPage; key: id; template: #searchResultTemplate; updateInPlace: true; pool: 6; delay: 25"
  layout="type: box; columns: 1; marginRow: -0.2; orderAttribute: data-index" search-result-list position="0 0.644 0">
</a-entity>

<!-- All search result text merged and spaced out. -->
<a-entity id="searchSongNameTexts" mixin="font" bind__text="value: search.songNameTexts" render-order="menutext"
  text="baseline: top; align: left; color: #FAFAFA; wrapCount: 28; lineHeight: 130" position="0.181 0.51943 0.001">
</a-entity>
<a-entity id="searchSongSubNameTexts" mixin="font"
  bind__text="color: colorSecondaryBright; value: search.songSubNameTexts" render-order="menutext"
  text="baseline: top; align: left; wrapCount: 42; lineHeight: 190" position="0.181 0.445 0.001">
</a-entity>

<a-entity id="searchThumbnailImages" bind__search-thumbnail-atlas="dummyUpdater: search.songSubNameTexts"
  bind__visible="searchResultsPage.length > 0" geometry="primitive: plane; buffer: false; width: 0.2; height: 1.2"
  dynamic-texture-atlas="canvasId: thumbnailAtlasMap; canvasWidth: 64; canvasHeight: 512; numColumns: 1; numRows: 6"
  material="shader: flat; transparent: true" render-order="menubutton" position="-0.45 0.0146 0.002"></a-entity>

<a-mixin id="searchPageButton"
  animation__mouseenter="property: components.slice9.material.opacity; from: 0; to: 0.3; startEvents: mouseenter; pauseEvents: mouseleave; dur: 150"
  animation__mouseleave="property: components.slice9.material.opacity; from: 0.3; to: 0; startEvents: mouseleave; pauseEvents: mouseenter; dur: 150"
  mixin="slice" raycaster-target="width: 1; height: 0.32" render-order="menubutton"
  slice9="width: 0.8; color: #08bfa2; height: 0.130; padding: 0.03; opacity: 0"></a-mixin>

<a-entity id="searchPrevPage" mixin="searchPageButton" bind__slice9="color: colorPrimary"
  bind__visible-raycastable="search.hasPrev && (mainMenuActive || isSearching)"
  raycaster-target="bindToggle: search.hasNext && menuActive; position: 0 0.08 0" position="-0 0.69 0.01"
  proxy-event="event: click; to: a-scene; as: searchprevpage; captureBubbles: true">
  <a-entity id="prevArrow" bind__material="color: colorPrimary" geometry="primitive: plane; width: 0.12; height: 0.12"
    material="shader: flat; src: #downIconImg; transparent: true" rotation="0 0 180" position="0 0 -0.001"></a-entity>
</a-entity>

<a-entity id="searchNextPage" mixin="searchPageButton" bind__slice9="color: colorSecondary"
  raycaster-target="bindToggle: search.hasNext && (mainMenuActive || isSearching); position: 0 -0.08 0"
  position="-0 -0.674 0.01" proxy-event="event: click; to: a-scene; as: searchnextpage; captureBubbles: true"
  bind__visible="search.hasNext">
  <a-entity id="nextArrow" bind__material="color: colorSecondary" geometry="primitive: plane; width: 0.12; height: 0.12"
    material="shader: flat; src: #downIconImg; transparent: true" position="0 0 -0.001"></a-entity>
</a-entity>

    </a-entity>

    <a-entity id="menuDifficultiesGroup" position="0 0.18 0">

      <!-- Top-aligned. -->
      <!-- Uses bind-for and bind-item to render difficulties. -->
      <a-entity id="menuDifficulties" bind-for="for: item; in: menuDifficultiesIds; updateInPlace: true; pool: 10"
        bind__visible="!!menuSelectedChallenge.id"
        layout="type: box; columns: 1; marginRow: -0.2; orderAttribute: data-bind-for-key" position="0 0.34 0"
        menu-difficulty-select>
        
        <template>
          <!-- Item is a string representing the difficulty. -->
          <a-entity class="difficultyOption" bind-item__data-difficulty="item">
            <a-entity class="difficultyBackground"
              bind-item__active-item="active: (menuSelectedChallenge.difficultyId === item)"
              bind-item__animation__mouseenter="enabled: !(menuSelectedChallenge.difficultyId === item)"
              bind-item__animation__mouseleave="enabled: !(menuSelectedChallenge.difficultyId === item)"
              bind-item__difficulty-background="enabled: menuActive && !!menuSelectedChallenge.id && !(menuSelectedChallenge.difficultyId === item) && !difficultyFilterMenuOpen"
              bind__material="color: colorPrimary" geometry="primitive: plane; width: 0.4; height: 0.2"
              material="shader: flat; transparent: true; opacity: 0.0; src: #difficultyImg" position="0 -0.005 0"
              play-sound="event: mouseenter; sound: #hoverSound; volume: 0.03"
              animation__mouseenter="property: components.material.material.opacity; to: 0.3; startEvents: mouseenter; pauseEvents: mouseleave; dur: 75"
              event-set__mouseenter="visible: true"
              animation__mouseleave="property: components.material.material.opacity; to: 0.0; startEvents: mouseleave; pauseEvents: mouseenter; dur: 75"
              event-set__mouseleave="visible: true; _delay: 160" render-order="menuitem"></a-entity>
            <a-entity class="difficultyText" mixin="font"
              bind-item__active-text-color="active: (menuSelectedChallenge.difficultyId === item)"
              bind-item__difficulty-text="id: item" active-text-color="color: #fff"
              text="wrapCount: 30; align: center; color: #8d8d8d" position="0 -0.057 0.001" render-order="menutext">
            </a-entity>
          </a-entity>
        </template>
        
      </a-entity>
    </a-entity>

    <!-- Selected challenge info. -->
    <a-entity id="menuSelectedChallengePanel" bind__visible="!!menuSelectedChallenge.id"
      position="0.8394583182784089 0 0.001">
      <a-entity id="menuFavoriteButton" bind__animation__mouseenter="to: menuSelectedChallenge.isFavorited && 0.25 || 1"
        bind__animation__mouseleave="to: menuSelectedChallenge.isFavorited && 1 || 0.25"
        bind__material="color: colorTertiary; opacity: menuSelectedChallenge.isFavorited && 1 || 0.25"
        bind__raycastable="menuActive && !!menuSelectedChallenge.id"
        animation__mouseenter="property: components.material.material.opacity; startEvents: mouseenter; dur: 150; easing: easeInOutCubic"
        animation__mouseleave="property: components.material.material.opacity; startEvents: mouseleave; dur: 100; easing: easeInOutCubic"
        geometry="primitive: plane; width: 0.1; height: 0.1"
        material="src: #favoriteImg; shader: flat; transparent: true; opacity: 0.25"
        play-sound__hover="event: mouseenter; sound: #hoverSound; volume: 0.1" position="0.46 0.68 0.001"
        proxy-event="event: click; to: a-scene; as: favoritetoggle" render-order="menuitem"></a-entity>

      <a-entity id="menuSelectedChallengeImage"
        bind__menu-selected-challenge-image="coverURL: menuSelectedChallenge.coverURL"
        geometry="primitive: plane; height: 0.4; width: 0.4" material="shader: flat" position="0 0.42 0"></a-entity>

      <a-entity id="menuSelectedChallengeInfoContainer" position="0 0.058 0">
        <a-entity id="menuSelectedChallengeSongAuthor" mixin="font"
          bind__text="color: colorSecondaryBright; value: (menuSelectedChallenge.metadata.songSubName || menuSelectedChallenge.metadata.songAuthorName || 'Unknown Artist')" position="0 0.042 0"
          render-order="menutext" text="wrapCount: 40; lineHeight: 40; width: 1.185; align: center; baseline: center">
        </a-entity>
        <a-entity id="menuSelectedChallengeSongName" mixin="font"
          bind__text="color: colorPrimary; value: menuSelectedChallenge.metadata.songName" position="0 -0.059 0"
          render-order="menutext" text="align: center; wrapCount: 31; baseline: top; lineHeight: 36; width: 1.4">
        </a-entity>
        <a-entity id="menuSelectedChallengeInfo" mixin="font" bind__text="value: menuSelectedChallenge.songInfoText"
          mixin="font" position="0 -0.18 0" render-order="menutext"
          text="align: center; color: #989898; wrapCount: 55; lineHeight: 72; width: 1.5; baseline: top"></a-entity>
      </a-entity>

      <a-entity id="playButton"
        bind__visible-raycastable="menuActive && !!menuSelectedChallenge.id && !genreMenuOpen && !difficultyFilterMenuOpen && !isIOS && !hasSongLoadError"
        geometry="primitive: plane; width: 0.7; height: 0.25"
        play-sound="event: mouseenter; sound: #hoverSound; volume: 0.03"
        play-sound__click="event: click; sound: #confirmSound; volume: 0.25" position="0 -0.561 0"
        proxy-event="event: click; to: a-scene; as: playbuttonclick"
        material="shader: panelShader; brightness: 0.7; transparent: true; midSection: 0; ratio: 2.8; borderRadius: 0.6; borderWidth: 0.08"
        render-order="menubutton"
        animation__mouseenter1="property: components.material.material.uniforms.activePanel.value; from: 0; to: 1; startEvents: mouseenter; pauseEvents: mouseleave; dur: 100"
        animation__mouseleave1="property: components.material.material.uniforms.activePanel.value; from: 1; to: 0; startEvents: mouseleave; pauseEvents: mouseenter; dur: 100"
        animation__mouseenter2="property: scale; from: 1 1 1; to: 1.1 1.1 1.1; startEvents: mouseenter; pauseEvents: mouseleave; dur: 100"
        animation__mouseleave2="property: scale; to: 1 1 1; from: 1.1 1.1 1.1; startEvents: mouseleave; pauseEvents: mouseenter; dur: 100">
        <a-entity mixin="font" text="align: center; color: #FFF; wrapCount: 15; value: PLAY" position="0 -0.085 0.01">
        </a-entity>
      </a-entity>

      <a-entity id="iOSNotice" bind__visible="mainMenuActive && isIOS" mixin="font" position="0 -0.5 0.01"
        text="align: center; baseline: top; color: #FFF; wrapCount: 32; value: Sorry, iOS is currently not playable but support is coming soon!">
      </a-entity>

      <a-entity id="menuLoadError" bind__visible="hasSongLoadError" mixin="font" position="0 -0.5 0.01"
        text="align: center; baseline: top; color: #FFF; wrapCount: 32; value: Sorry! There was an error loading this song.">
      </a-entity>
    </a-entity>

    <a-entity id="searchError" mixin="font" bind__visible="search.hasError" render-order="menuText"
      text="align: center; value: Sorry, there was an issue fetching search results. Please try again."
      position="0 0 0.01"></a-entity>

    <a-entity id="menuNoPlaylists" mixin="font"
      bind__visible="playlist === 'favorites' && favorites.length === 0 && !menuSelectedChallenge.id"
      render-order="menuText" position="0 0.1 0.01"
      text="align: center; baseline: top; color: #FFF; wrapCount: 32; value: Add a song to your favorites by clicking the star in the top right of the menu after selected a song.">
    </a-entity>

    <a-entity id="searchNoResults" mixin="font"
      bind__visible="!isSearching && search.results.length === 0 && playlist !== 'favorites'" render-order="menuText"
      text="align: center; value: No search results found. Please try again with another query." position="0 0 0.01">
    </a-entity>
  </a-entity>

  <!-- <require path="/home/lpv/repos/moonrider/src/templates/genreMenu.html"> -->
<a-entity
  id="genreMenu"
  bind-for="for: genre; in: genres; updateInPlace: true; key: name"
  bind__visible="genreMenuOpen"
  layout="type: box; columns: 6; marginRow: 0.4; marginColumn: 0.4; align: center"
  menu-genre
  position="0 0 0.05">
  <template>
    <a-entity class="genre" bind-item__data-genre="item">
      <a-entity
        mixin="slice"
        slice9="opacity: 0.9; width: 0.35; left: 70; top: 70; height: 0.35; padding: 0.07"
        animation__mouseenter2="property: scale; from: 1 1 1; to: 1.03 1.03 1.03; startEvents: mouseenter; pauseEvents: mouseleave; easing: easeOutCubic; dur: 150"
        animation__mouseleave2="property: scale; from: 1.03 1.03 1.03; to: 1 1 1; startEvents: mouseleave; pauseEvents: mouseenter; easing: easeOutCubic; dur: 150"
        proxy-event__enter="event: mouseenter; to: CHILDREN; captureBubbles: true"
        proxy-event__leave="event: mouseleave; to: CHILDREN; captureBubbles: true"
        play-sound__click="event: click; sound: #confirmSound; volume: 0.1"
        raycaster-target="bindToggle: genreMenuOpen; width: 0.35; height: 0.35"
        render-order__nonrecursive="menubutton">
        <a-entity
          mixin="font"
          bind-item__text="value: item.name"
          text="align: center; width: 1.1; color: #888"
          animation__mouseenter="property: components.text.material.uniforms.color.value; from: #888; to: #FFF; type: color; startEvents: mouseenter; pauseEvents: mouseleave; easing: easeOutCubic; dur: 150"
          animation__mouseleave="property: components.text.material.uniforms.color.value; from: #FFF; to: #888; type: color; startEvents: mouseleave; pauseEvents: mouseenter; easing: easeOutCubic; dur: 150"
          render-order="menutext"
          position="0 -0.16 0.001"></a-entity>
        <a-entity
          class="genreIcon"
          bind-item__atlas-uvs="totalColumns: 6; totalRows: 3; row: item.row; column: item.column"
          geometry="primitive: plane; width: 0.22; height: 0.22; buffer: false; skipCache: true"
          position="0 0.04 0.002"
          material="shader: flat; src: #genresImg; transparent: true; color: #888"
          render-order="menutext"
          animation__mouseenter="property: components.material.material.color; type: color; from: #888; to: #FFF; startEvents: mouseenter; pauseEvents: mouseleave; easing: easeOutCubic; dur: 150"
          animation__mouseleave="property: components.material.material.color; type: color; from: #FAFAFA; to: #888; startEvents: mouseleave; pauseEvents: mouseenter; easing: easeOutCubic; dur: 150"></a-entity>
      </a-entity>
    </a-entity>
  </template>
</a-entity>
<!-- </require> --></require>
  <!-- <require path="/home/lpv/repos/moonrider/src/templates/difficultyMenu.html"> -->




<a-entity
  id="difficultyFilterMenu"
  bind__visible="difficultyFilterMenuOpen"
  layout="type: box; columns: 1; marginRow: -0.2"
  difficulty-filter
  position="0 0.5 0">
  
    
  <a-entity class="difficultyFilterOption" data-difficulty-filter="All">
    <a-entity class="difficultyFilterBackground"
        bind__active-item="active: difficultyFilter === 'All'"
        bind__animation__mouseenter="enabled: difficultyFilter !== 'All'"
        bind__animation__mouseleave="enabled: difficultyFilter !== 'All'"
        bind__animation__mouseentervisible="enabled: difficultyFilter !== 'All'"
        bind__animation__mouseleavevisible="enabled: difficultyFilter !== 'All'"
        bind__difficulty-background="enabled: difficultyFilterMenuOpen && difficultyFilter !== 'All'"
        bind__material="color: colorPrimary"
        animation__mouseenter="property: components.material.material.opacity; to: 0.3; startEvents: mouseenter; dur: 150"
        animation__mouseleave="property: components.material.material.opacity; to: 0.0; startEvents: mouseleave; dur: 75"
        event-set__mouseenter="visible: true"
        event-set__mouseleave="visible: true; _delay: 160"
        geometry="primitive: plane; width: 0.4; height: 0.2"
        material="shader: flat; transparent: true; opacity: 0; src: #difficultyImg"
        position="0 -0.005 0"
        play-sound="event: mouseenter; sound: #hoverSound; volume: 0.03"
        render-order="menuitem"></a-entity>
    <a-entity
      class="difficultyFilterText"
      mixin="font"
      bind__active-text-color="active: difficultyFilter === 'All'"
      active-text-color="color: #fff"
      difficulty-text="difficulty: All"
      text="wrapCount: 30; align: center; color: #8d8d8d"
      position="0 -0.057 0.001"
      render-order="menutext"></a-entity>
  </a-entity>

  
    
  <a-entity class="difficultyFilterOption" data-difficulty-filter="Easy">
    <a-entity class="difficultyFilterBackground"
        bind__active-item="active: difficultyFilter === 'Easy'"
        bind__animation__mouseenter="enabled: difficultyFilter !== 'Easy'"
        bind__animation__mouseleave="enabled: difficultyFilter !== 'Easy'"
        bind__animation__mouseentervisible="enabled: difficultyFilter !== 'Easy'"
        bind__animation__mouseleavevisible="enabled: difficultyFilter !== 'Easy'"
        bind__difficulty-background="enabled: difficultyFilterMenuOpen && difficultyFilter !== 'Easy'"
        bind__material="color: colorPrimary"
        animation__mouseenter="property: components.material.material.opacity; to: 0.3; startEvents: mouseenter; dur: 150"
        animation__mouseleave="property: components.material.material.opacity; to: 0.0; startEvents: mouseleave; dur: 75"
        event-set__mouseenter="visible: true"
        event-set__mouseleave="visible: true; _delay: 160"
        geometry="primitive: plane; width: 0.4; height: 0.2"
        material="shader: flat; transparent: true; opacity: 0; src: #difficultyImg"
        position="0 -0.005 0"
        play-sound="event: mouseenter; sound: #hoverSound; volume: 0.03"
        render-order="menuitem"></a-entity>
    <a-entity
      class="difficultyFilterText"
      mixin="font"
      bind__active-text-color="active: difficultyFilter === 'Easy'"
      active-text-color="color: #fff"
      difficulty-text="difficulty: Easy"
      text="wrapCount: 30; align: center; color: #8d8d8d"
      position="0 -0.057 0.001"
      render-order="menutext"></a-entity>
  </a-entity>

  
    
  <a-entity class="difficultyFilterOption" data-difficulty-filter="Normal">
    <a-entity class="difficultyFilterBackground"
        bind__active-item="active: difficultyFilter === 'Normal'"
        bind__animation__mouseenter="enabled: difficultyFilter !== 'Normal'"
        bind__animation__mouseleave="enabled: difficultyFilter !== 'Normal'"
        bind__animation__mouseentervisible="enabled: difficultyFilter !== 'Normal'"
        bind__animation__mouseleavevisible="enabled: difficultyFilter !== 'Normal'"
        bind__difficulty-background="enabled: difficultyFilterMenuOpen && difficultyFilter !== 'Normal'"
        bind__material="color: colorPrimary"
        animation__mouseenter="property: components.material.material.opacity; to: 0.3; startEvents: mouseenter; dur: 150"
        animation__mouseleave="property: components.material.material.opacity; to: 0.0; startEvents: mouseleave; dur: 75"
        event-set__mouseenter="visible: true"
        event-set__mouseleave="visible: true; _delay: 160"
        geometry="primitive: plane; width: 0.4; height: 0.2"
        material="shader: flat; transparent: true; opacity: 0; src: #difficultyImg"
        position="0 -0.005 0"
        play-sound="event: mouseenter; sound: #hoverSound; volume: 0.03"
        render-order="menuitem"></a-entity>
    <a-entity
      class="difficultyFilterText"
      mixin="font"
      bind__active-text-color="active: difficultyFilter === 'Normal'"
      active-text-color="color: #fff"
      difficulty-text="difficulty: Normal"
      text="wrapCount: 30; align: center; color: #8d8d8d"
      position="0 -0.057 0.001"
      render-order="menutext"></a-entity>
  </a-entity>

  
    
  <a-entity class="difficultyFilterOption" data-difficulty-filter="Hard">
    <a-entity class="difficultyFilterBackground"
        bind__active-item="active: difficultyFilter === 'Hard'"
        bind__animation__mouseenter="enabled: difficultyFilter !== 'Hard'"
        bind__animation__mouseleave="enabled: difficultyFilter !== 'Hard'"
        bind__animation__mouseentervisible="enabled: difficultyFilter !== 'Hard'"
        bind__animation__mouseleavevisible="enabled: difficultyFilter !== 'Hard'"
        bind__difficulty-background="enabled: difficultyFilterMenuOpen && difficultyFilter !== 'Hard'"
        bind__material="color: colorPrimary"
        animation__mouseenter="property: components.material.material.opacity; to: 0.3; startEvents: mouseenter; dur: 150"
        animation__mouseleave="property: components.material.material.opacity; to: 0.0; startEvents: mouseleave; dur: 75"
        event-set__mouseenter="visible: true"
        event-set__mouseleave="visible: true; _delay: 160"
        geometry="primitive: plane; width: 0.4; height: 0.2"
        material="shader: flat; transparent: true; opacity: 0; src: #difficultyImg"
        position="0 -0.005 0"
        play-sound="event: mouseenter; sound: #hoverSound; volume: 0.03"
        render-order="menuitem"></a-entity>
    <a-entity
      class="difficultyFilterText"
      mixin="font"
      bind__active-text-color="active: difficultyFilter === 'Hard'"
      active-text-color="color: #fff"
      difficulty-text="difficulty: Hard"
      text="wrapCount: 30; align: center; color: #8d8d8d"
      position="0 -0.057 0.001"
      render-order="menutext"></a-entity>
  </a-entity>

  
    
  <a-entity class="difficultyFilterOption" data-difficulty-filter="Expert">
    <a-entity class="difficultyFilterBackground"
        bind__active-item="active: difficultyFilter === 'Expert'"
        bind__animation__mouseenter="enabled: difficultyFilter !== 'Expert'"
        bind__animation__mouseleave="enabled: difficultyFilter !== 'Expert'"
        bind__animation__mouseentervisible="enabled: difficultyFilter !== 'Expert'"
        bind__animation__mouseleavevisible="enabled: difficultyFilter !== 'Expert'"
        bind__difficulty-background="enabled: difficultyFilterMenuOpen && difficultyFilter !== 'Expert'"
        bind__material="color: colorPrimary"
        animation__mouseenter="property: components.material.material.opacity; to: 0.3; startEvents: mouseenter; dur: 150"
        animation__mouseleave="property: components.material.material.opacity; to: 0.0; startEvents: mouseleave; dur: 75"
        event-set__mouseenter="visible: true"
        event-set__mouseleave="visible: true; _delay: 160"
        geometry="primitive: plane; width: 0.4; height: 0.2"
        material="shader: flat; transparent: true; opacity: 0; src: #difficultyImg"
        position="0 -0.005 0"
        play-sound="event: mouseenter; sound: #hoverSound; volume: 0.03"
        render-order="menuitem"></a-entity>
    <a-entity
      class="difficultyFilterText"
      mixin="font"
      bind__active-text-color="active: difficultyFilter === 'Expert'"
      active-text-color="color: #fff"
      difficulty-text="difficulty: Expert"
      text="wrapCount: 30; align: center; color: #8d8d8d"
      position="0 -0.057 0.001"
      render-order="menutext"></a-entity>
  </a-entity>

  
    
  <a-entity class="difficultyFilterOption" data-difficulty-filter="Expertplus">
    <a-entity class="difficultyFilterBackground"
        bind__active-item="active: difficultyFilter === 'Expertplus'"
        bind__animation__mouseenter="enabled: difficultyFilter !== 'Expertplus'"
        bind__animation__mouseleave="enabled: difficultyFilter !== 'Expertplus'"
        bind__animation__mouseentervisible="enabled: difficultyFilter !== 'Expertplus'"
        bind__animation__mouseleavevisible="enabled: difficultyFilter !== 'Expertplus'"
        bind__difficulty-background="enabled: difficultyFilterMenuOpen && difficultyFilter !== 'Expertplus'"
        bind__material="color: colorPrimary"
        animation__mouseenter="property: components.material.material.opacity; to: 0.3; startEvents: mouseenter; dur: 150"
        animation__mouseleave="property: components.material.material.opacity; to: 0.0; startEvents: mouseleave; dur: 75"
        event-set__mouseenter="visible: true"
        event-set__mouseleave="visible: true; _delay: 160"
        geometry="primitive: plane; width: 0.4; height: 0.2"
        material="shader: flat; transparent: true; opacity: 0; src: #difficultyImg"
        position="0 -0.005 0"
        play-sound="event: mouseenter; sound: #hoverSound; volume: 0.03"
        render-order="menuitem"></a-entity>
    <a-entity
      class="difficultyFilterText"
      mixin="font"
      bind__active-text-color="active: difficultyFilter === 'Expertplus'"
      active-text-color="color: #fff"
      difficulty-text="difficulty: Expertplus"
      text="wrapCount: 30; align: center; color: #8d8d8d"
      position="0 -0.057 0.001"
      render-order="menutext"></a-entity>
  </a-entity>

  
</a-entity>
<!-- </require> --></require>
  <!-- <require path="/home/lpv/repos/moonrider/src/templates/optionsMenu.html"> -->
<a-entity
  id="optionsMenu"
  bind__visible="optionsMenuOpen"
  position="0 0.5 0.01"
  render-order="menutext">

  <a-entity id="optionsTitle" mixin="font" text="align: center; value: OPTIONS; width: 2.5"></a-entity>

  <a-entity id="colorOptionsContainer" position="0 -0.25 0">
    <a-entity id="colorTitle" mixin="font" text="align: center; value: THEMES; width: 2"></a-entity>

    <a-entity id="colorOptions" position="-0.79 -0.175 0.00" layout="type: box; columns: 10; margin: 0.2" materials-color-menu>
      
        <a-entity
          class="colorOption"
          data-color-name="Super Medium"
          data-color-scheme="default"
          mixin="clickSoundUI hoverSoundUI"
          animation__mouseenter="property: scale; to: 1.2 1.2 1.2; dur: 150; easing: easeInOutCubic; startEvents: mouseenter"
          animation__mouseleave="property: scale; to: 1 1 1; dur: 125; easing: easeInOutCubic; startEvents: mouseleave"
          geometry="primitive: plane; width: 0.15; height: 0.15"
          material="shader: gradientShader; color1: #f971c3; color2: #6ff9ea; transparent: true"
          render-order="menutext"
          bind-toggle__raycastable="optionsMenuOpen">
        </a-entity>
      
        <a-entity
          class="colorOption"
          data-color-name="Star Warrior"
          data-color-scheme="blue"
          mixin="clickSoundUI hoverSoundUI"
          animation__mouseenter="property: scale; to: 1.2 1.2 1.2; dur: 150; easing: easeInOutCubic; startEvents: mouseenter"
          animation__mouseleave="property: scale; to: 1 1 1; dur: 125; easing: easeInOutCubic; startEvents: mouseleave"
          geometry="primitive: plane; width: 0.15; height: 0.15"
          material="shader: gradientShader; color1: #1e4482; color2: #c27727; transparent: true"
          render-order="menutext"
          bind-toggle__raycastable="optionsMenuOpen">
        </a-entity>
      
        <a-entity
          class="colorOption"
          data-color-name="Galactic Royal"
          data-color-scheme="purple"
          mixin="clickSoundUI hoverSoundUI"
          animation__mouseenter="property: scale; to: 1.2 1.2 1.2; dur: 150; easing: easeInOutCubic; startEvents: mouseenter"
          animation__mouseleave="property: scale; to: 1 1 1; dur: 125; easing: easeInOutCubic; startEvents: mouseleave"
          geometry="primitive: plane; width: 0.15; height: 0.15"
          material="shader: gradientShader; color1: #6A39B3; color2: #FAF239; transparent: true"
          render-order="menutext"
          bind-toggle__raycastable="optionsMenuOpen">
        </a-entity>
      
        <a-entity
          class="colorOption"
          data-color-name="Space Joker"
          data-color-scheme="green"
          mixin="clickSoundUI hoverSoundUI"
          animation__mouseenter="property: scale; to: 1.2 1.2 1.2; dur: 150; easing: easeInOutCubic; startEvents: mouseenter"
          animation__mouseleave="property: scale; to: 1 1 1; dur: 125; easing: easeInOutCubic; startEvents: mouseleave"
          geometry="primitive: plane; width: 0.15; height: 0.15"
          material="shader: gradientShader; color1: #779E37; color2: #6A39B3; transparent: true"
          render-order="menutext"
          bind-toggle__raycastable="optionsMenuOpen">
        </a-entity>
      
        <a-entity
          class="colorOption"
          data-color-name="Solar Flare"
          data-color-scheme="yellow"
          mixin="clickSoundUI hoverSoundUI"
          animation__mouseenter="property: scale; to: 1.2 1.2 1.2; dur: 150; easing: easeInOutCubic; startEvents: mouseenter"
          animation__mouseleave="property: scale; to: 1 1 1; dur: 125; easing: easeInOutCubic; startEvents: mouseleave"
          geometry="primitive: plane; width: 0.15; height: 0.15"
          material="shader: gradientShader; color1: #C2C04C; color2: #E03A3E; transparent: true"
          render-order="menutext"
          bind-toggle__raycastable="optionsMenuOpen">
        </a-entity>
      
        <a-entity
          class="colorOption"
          data-color-name="Trail Blazer"
          data-color-scheme="red"
          mixin="clickSoundUI hoverSoundUI"
          animation__mouseenter="property: scale; to: 1.2 1.2 1.2; dur: 150; easing: easeInOutCubic; startEvents: mouseenter"
          animation__mouseleave="property: scale; to: 1 1 1; dur: 125; easing: easeInOutCubic; startEvents: mouseleave"
          geometry="primitive: plane; width: 0.15; height: 0.15"
          material="shader: gradientShader; color1: #E03A3E; color2: #DADADA; transparent: true"
          render-order="menutext"
          bind-toggle__raycastable="optionsMenuOpen">
        </a-entity>
      
        <a-entity
          class="colorOption"
          data-color-name="Mint Choco"
          data-color-scheme="rgb"
          mixin="clickSoundUI hoverSoundUI"
          animation__mouseenter="property: scale; to: 1.2 1.2 1.2; dur: 150; easing: easeInOutCubic; startEvents: mouseenter"
          animation__mouseleave="property: scale; to: 1 1 1; dur: 125; easing: easeInOutCubic; startEvents: mouseleave"
          geometry="primitive: plane; width: 0.15; height: 0.15"
          material="shader: gradientShader; color1: #34eb89; color2: #34ebd8; transparent: true"
          render-order="menutext"
          bind-toggle__raycastable="optionsMenuOpen">
        </a-entity>
      
        <a-entity
          class="colorOption"
          data-color-name="Cheetah SoL"
          data-color-scheme="cheetah"
          mixin="clickSoundUI hoverSoundUI"
          animation__mouseenter="property: scale; to: 1.2 1.2 1.2; dur: 150; easing: easeInOutCubic; startEvents: mouseenter"
          animation__mouseleave="property: scale; to: 1 1 1; dur: 125; easing: easeInOutCubic; startEvents: mouseleave"
          geometry="primitive: plane; width: 0.15; height: 0.15"
          material="shader: gradientShader; color1: #c27727; color2: #635c54; transparent: true"
          render-order="menutext"
          bind-toggle__raycastable="optionsMenuOpen">
        </a-entity>
      
        <a-entity
          class="colorOption"
          data-color-name="Ash Nova"
          data-color-scheme="black"
          mixin="clickSoundUI hoverSoundUI"
          animation__mouseenter="property: scale; to: 1.2 1.2 1.2; dur: 150; easing: easeInOutCubic; startEvents: mouseenter"
          animation__mouseleave="property: scale; to: 1 1 1; dur: 125; easing: easeInOutCubic; startEvents: mouseleave"
          geometry="primitive: plane; width: 0.15; height: 0.15"
          material="shader: gradientShader; color1: #555; color2: #FFF; transparent: true"
          render-order="menutext"
          bind-toggle__raycastable="optionsMenuOpen">
        </a-entity>
      
    </a-entity>

    <a-entity
      id="colorName"
      mixin="font"
      text="align: center; color: #CCC; width: 1"
      position="0 -0.35 0.1"
      render-order="menutext"></a-entity>
  </a-entity>
</a-entity>
<!-- </require> --></require>
  <!-- <require path="/home/lpv/repos/moonrider/src/templates/playlistMenu.html"> -->
<a-entity
  id="playlistMenu"
  bind-for="for: playlist; in: playlists; updateInPlace: true; key: name"
  bind__visible="playlistMenuOpen"
  layout="type: box; columns: 2; marginRow: -0.23; marginColumn: 1.3; align: center"
  menu-playlist
  position="0 0 0.05">
  <template>
    
    <a-entity class="playlist" data-playlist="{{ item.name }}" data-title="{{ item.title }}">
    
      <a-entity
        mixin="slice"
        slice9="opacity: 0.9; width: 1.2; left: 70; top: 70; height: 0.19; padding: 0.07"
        animation__mouseenter="property: scale; from: 1 1 1; to: 1.03 1.03 1.03; startEvents: mouseenter; pauseEvents: mouseleave; easing: easeOutCubic; dur: 150"
        animation__mouseleave="property: scale; from: 1.03 1.03 1.03; to: 1 1 1; startEvents: mouseleave; pauseEvents: mouseenter; easing: easeOutCubic; dur: 150"
        proxy-event__enter="event: mouseenter; to: CHILDREN; captureBubbles: true"
        proxy-event__leave="event: mouseleave; to: CHILDREN; captureBubbles: true"
        play-sound__click="event: click; sound: #confirmSound; volume: 0.1"
        raycaster-target="bindToggle: playlistMenuOpen; width: 1.2; height: 0.19"
        render-order__nonrecursive="menubutton">
        <a-entity
          class="playlistTitle"
          mixin="font"
          bind-item__text-uppercase="value: item.title"
          text="align: left; width: 1.3; color: #CCC"
          animation__mouseenter="property: components.text.material.uniforms.color.value; from: #CCC; to: #FFF; type: color; startEvents: mouseenter; pauseEvents: mouseleave; easing: easeOutCubic; dur: 150"
          animation__mouseleave="property: components.text.material.uniforms.color.value; from: #FFF; to: #CCC; type: color; startEvents: mouseleave; pauseEvents: mouseenter; easing: easeOutCubic; dur: 150"
          render-order="menutext"
          position="0.11 -0.01 0.001"></a-entity>

        <a-entity
          class="playlistAuthor"
          mixin="font"
          bind-item__text="value: item.author"
          bind__text="color: colorPrimary"
          text="align: left; width: 1.1"
          render-order="menutext"
          position="0.01 -0.08 0.001"></a-entity>
      </a-entity>
    </a-entity>
  </template>
</a-entity>
<!-- </require> --></require>
</a-entity>

<!-- Search. -->
<a-entity id="keyboard"
  bind__super-keyboard="hand: activeHand === 'left' && '#leftHand' || '#rightHand'; show: isSearching"
  super-keyboard="label: Search on beatsaver.com; inputColor: #fff; labelColor: #f0f0f0; width: 1.5; hand: #rightHand; imagePath: assets/img/keyboard; font: assets/fonts/Viga-Regular.json; align: center; model: superkeyboard; keyColor: #fff; injectToRaycasterObjects: false; filters: allupper; keyHoverColor: #fff"
  position="0.58 1.2 -1.95" keyboard-raycastable="condition: isSearching" search
  proxy-event__dismiss="event: superkeyboarddismiss; to: a-scene; as: keyboardclose"
  proxy-event__accept="event: superkeyboardinput; to: a-scene; as: keyboardclose" render-order="menubutton"
  render-order-recursive>
</a-entity>

<a-entity id="backButton" mixin="bigMenuTopButton"
  bind__visible-raycastable="genreMenuOpen || isSearching || difficultyFilterMenuOpen || playlistMenuOpen || optionsMenuOpen"
  position="0 2.32 -1.96" play-sound__hover="event: mouseenter; sound: #hoverSound; volume: 0.1"
  proxy-event="event: click; to: a-scene; as: menuback">
  <a-entity mixin="font" text="align: center; color: #FFF; wrapCount: 20; value: BACK" position="0 -0.07 0.01">
  </a-entity>
</a-entity>

<!-- Top menu buttons. -->
<a-mixin id="bigMenuTopButton" mixin="bigMenuButton" geometry="height: 0.17; width: 0.7"></a-mixin>
<a-mixin id="bigMenuTopButtonFont" mixin="font" text="width: 0.75" position="0 -0.05 0.01"></a-mixin>
<a-entity id="menuTopButtons"
  animation__position="property: object3D.position.z; to: -1.98; dur: 1500; easing: easeInOutCubic; delay: 300; startEvents: startgame"
  layout="type: line; margin: 0.65" position="-0.95 2.30 -1.96"
  proxy-event="event: startgame; to: #searchButton, #difficultyButton, #genreButton, #playlistButton, #optionButton">

  <!-- Playlist menu toggle. -->
    <a-entity id="playlistButtons">
    <a-entity id="playlistButton"
      mixin="bigMenuTopButton"
      bind__menu-playlist-button="isFavorited: menuSelectedChallenge.isFavorited; selectedChallenge: menuSelectedChallenge.id"
      bind__visible-raycastable="mainMenuActive && !playlist"
      material="opacity: 0"
      animation__opacity="property: components.material.material.uniforms.opacity.value; from: 0; to: 1; dur: 1000; delay: 300; startEvents: startgame"
      play-sound__hover="event: mouseenter; sound: #hoverSound; volume: 0.1"
      proxy-event="event: click; to: a-scene; as: playlistmenuopen">
      <a-entity mixin="bigMenuTopButtonFont" text="align: center; color: #FFF; wrapCount: 20; value: PLAYLISTS" bind__visible="!isMenuOpening"></a-entity>
    </a-entity>

    <a-entity id="clearPlaylistButton"
      mixin="bigMenuTopButton"
      bind__visible-raycastable="menuActive && !!playlist"
      play-sound__hover="event: mouseenter; sound: #hoverSound; volume: 0.1"
      play-sound__click="event: click; sound: #clearSound"
      proxy-event="event: click; to: a-scene; as: playlistclear">
      <a-entity mixin="bigMenuTopButtonFont" text="align: center; color: #FFF; wrapCount: 20; value: CLEAR PLAYLIST"></a-entity>
    </a-entity>

    <a-entity
      id="playlistText"
      mixin="font"
      bind__text="color: colorPrimary"
      bind__text-uppercase="value: playlistTitle"
      bind__visible="mainMenuActive && !!playlist"
      text="align: center; baseline: bottom; wrapCount: 30; width: 0.7"
      position="0 0.1 0.035"
      render-order="menutext"></a-entity>
  </a-entity>

  <!-- Search toggle. -->
    <a-entity id="searchButtons">
    <a-entity
      id="searchButton"
      mixin="bigMenuTopButton"
      bind__visible-raycastable="mainMenuActive && !search.query"
      material="opacity: 0"
      animation__opacity="property: components.material.material.uniforms.opacity.value; from: 0; to: 1; dur: 1000; delay: 300; startEvents: startgame"
      play-sound__hover="event: mouseenter; sound: #hoverSound; volume: 0.1"
      proxy-event="event: click; to: a-scene; as: keyboardopen">
      <a-entity mixin="bigMenuTopButtonFont" text="align: center; color: #FFF; wrapCount: 20; value: SEARCH" bind__visible="!isMenuOpening"></a-entity>
    </a-entity>

    <a-entity id="searchClearButton"
      mixin="bigMenuTopButton"
      bind__visible-raycastable="mainMenuActive && !!search.query"
      play-sound__hover="event: mouseenter; sound: #hoverSound; volume: 0.1"
      play-sound__click="event: click; sound: #clearSound"
      proxy-event="event: click; to: a-scene; as: searchclear">
      <a-entity mixin="bigMenuTopButtonFont" text="align: center; color: #FFF; wrapCount: 20; value: CLEAR SEARCH"></a-entity>
    </a-entity>

    <a-entity
      id="searchText"
      mixin="font"
      bind__text="color: colorPrimary"
      bind__text-uppercase="value: search.queryText"
      bind__visible="mainMenuActive && !!search.query"
      text="align: center; wrapCount: 20"
      position="0 0.1 0.035"
      render-order="menutext"></a-entity>
  </a-entity>

  <!-- Difficulty menu toggle. -->
  <!--   <a-entity id="difficultyFilter">
    <a-entity id="difficultyButton"
      mixin="bigMenuTopButton"
      material="opacity: 0"
      bind__visible-raycastable="mainMenuActive"
      animation__opacity="property: components.material.material.uniforms.opacity.value; from: 0; to: 1; dur: 1000; delay: 300; startEvents: startgame"
      play-sound__hover="event: mouseenter; sound: #hoverSound; volume: 0.1"
      proxy-event="event: click; to: a-scene; as: difficultyfiltermenuopen">
      <a-entity mixin="bigMenuTopButtonFont" text="align: center; color: #FFF; wrapCount: 20; value: DIFFICULTY" bind__visible="!isMenuOpening"></a-entity>
    </a-entity>

    <a-entity
      id="difficultyFilterText"
      mixin="font"
      bind__difficulty-text="difficulty: difficultyFilter"
      bind__text="color: colorPrimary"
      bind__visible="mainMenuActive && difficultyFilter !== 'All'"
      text="align: center; wrapCount: 20"
      position="0 0.1 0.035"
      render-order="menutext"></a-entity>
  </a-entity> -->

  <!-- Genre menu toggle. -->
    <a-entity id="genreButtons">
    <a-entity id="genreButton"
      mixin="bigMenuTopButton"
      bind__visible-raycastable="mainMenuActive && !genre"
      material="opacity: 0"
      animation__opacity="property: components.material.material.uniforms.opacity.value; from: 0; to: 1; dur: 1000; delay: 300; startEvents: startgame"
      play-sound__hover="event: mouseenter; sound: #hoverSound; volume: 0.1"
      proxy-event="event: click; to: a-scene; as: genremenuopen">
      <a-entity mixin="bigMenuTopButtonFont" text="align: center; color: #FFF; wrapCount: 20; value: GENRES" bind__visible="!isMenuOpening"></a-entity>
    </a-entity>

    <a-entity id="clearGenreButton"
      mixin="bigMenuTopButton"
      bind__visible-raycastable="mainMenuActive && !!genre"
      play-sound__hover="event: mouseenter; sound: #hoverSound; volume: 0.1"
      play-sound__click="event: click; sound: #clearSound"
      proxy-event="event: click; to: a-scene; as: genreclear">
      <a-entity mixin="bigMenuTopButtonFont" text="align: center; color: #FFF; wrapCount: 20; value: CLEAR GENRE"></a-entity>
    </a-entity>

    <a-entity
      id="genreText"
      mixin="font"
      bind__text="color: colorPrimary"
      bind__text-uppercase="value: genre"
      bind__visible="mainMenuActive && !!genre"
      text="align: center; wrapCount: 20"
      position="0 0.1 0.035"
      render-order="menutext"></a-entity>
  </a-entity>
</a-entity>

<!-- Options menu toggle. -->
<a-entity id="optionsButtons" position="0 0.45 -1.96">
  <a-entity id="optionButton" mixin="bigMenuButton" bind__visible-raycastable="mainMenuActive" material="opacity: 0"
    animation__opacity="property: components.material.material.uniforms.opacity.value; from: 0; to: 1; dur: 1000; delay: 300; startEvents: startgame"
    play-sound__hover="event: mouseenter; sound: #hoverSound; volume: 0.1"
    proxy-event="event: click; to: a-scene; as: optionsmenuopen">
    <a-entity mixin="bigMenuTopButtonFont" text="align: center; color: #FFF; wrapCount: 20; value: THEMES"
      bind__visible="!isMenuOpening"></a-entity>
  </a-entity>
</a-entity><!-- </require> --></require>
  <!-- <require path="/home/lpv/repos/moonrider/src/templates/modes.html"> -->
<a-mixin
  id="modeAnimations"
  animation__select="property: object3D.position.z; to: 0.06; dur: 200; easing: easeOutQuad; startEvents: select"
  animation__deselect="property: object3D.position.z; to: 0; dur: 200; easing: easeOutQuad; startEvents: deselect"></a-mixin>

<a-mixin
  id="modeThumbAnimations"
  animation__select="property: components.material.material.color; type: color; to: #FFF; dur: 200; easing: easeOutQuad; startEvents: select"
  animation__deselect="property: components.material.material.color; type: color; to: #888; dur: 200; easing: easeOutQuad; startEvents: deselect"></a-mixin>

<a-mixin
  id="modeBackgroundHover"
  animation__mouseenter="property: components.material.material.uniforms.borderWidth.value; from: 0.002; to: 0.01; startEvents: mouseenter; pauseEvents: mouseleave; easing: linear; dur: 150"
  animation__mouseleave="property: components.material.material.uniforms.borderWidth.value; from: 0.01; to: 0.002; startEvents: mouseleave; pauseEvents: mouseenter; easing: linear; dur: 150"
  play-sound__hover="event: mouseenter; sound: #hoverSound; volume: 0.3"
  play-sound__click="event: click; sound: #confirmSound; volume: 0.1"

  ></a-mixin>

<a-mixin
  id="modeBackgroundSelect"
  animation__select="property: components.material.material.uniforms.brightness.value; to: 0.5; startEvents: select; easing: easeOutQuad; dur: 200"
  animation__deselect="property: components.material.material.uniforms.brightness.value; to: 0.1; startEvents: deselect; easing: easeOutQuad; dur: 200"
  animation__select2="property: components.material.material.uniforms.borderWidth.value; to: 0.015; startEvents: select; easing: linear; dur: 200"
  animation__deselect2="property: components.material.material.uniforms.borderWidth.value; to: 0.002; startEvents: deselect; easing: linear; dur: 200"></a-mixin>



<a-entity
  id="modes"
  bind__menu-mode="colorScheme: colorScheme; hasVR: hasVR"
  bind__position="hasVR && '-2.56 1.3 -0.7' || '-2.56 1 -0.7'"
  bind__visible="menuActive && !isMenuOpening"
  rotation="0 60 0"
  render-order="menuitem">

  <a-entity id="modeIcon"
    geometry="primitive: cylinder;  height: 0.01; segmentsHeight: 1; radius: 0.1; segmentsRadial: 3"
    rotation="0 90 90"
    position="-1.275 0.32 0.1"
    materials="name: merkaba"
    animation="property: object3D.position.x; from: -1.275; to: -1.3; dir: alternate; easing: easeOutQuad; loop: true; dur: 900"></a-entity>

  <a-entity id="mode2d" bind__visible="!hasVR">
    

<a-entity
  id="moderide2d"
  class="modeItem"
  data-mode="ride"
  data-name="ride2d"
  position="0 0.75 0"
  mixin="modeAnimations">
  <a-entity
    class="modeBackground"
    bind-toggle__raycastable="menuActive && !hasVR"
    position="0 0 -0.01"
    geometry="primitive: plane; width: 3; height: 0.8"
    material="shader: panelShader; brightness: 0.1; ratio: 4; borderWidth: 0.002"
    mixin="modeBackgroundHover modeBackgroundSelect"></a-entity>
  <a-entity
    class="modeTitle"
    mixin="font"
    text="align: left; value: RIDE\nMODE; lineHeight: 45; width: 2.6"
    render-order="menutext"
    position="0.14 0.05 0"></a-entity>
  <a-entity
    class="modeThumb"
    mixin="modeThumbAnimations"
    geometry="primitive: plane; width: 0.7; height: 0.5"
    material="src: #modeRideImg; shader: flat"
    position="-0.20 0 0"></a-entity>
  <a-entity
    class="modeInstructions"
    mixin="font"
    render-order="menutext"
    bind__text="color: colorPrimary"
    text="value: Relax and enjoy the ride.; width: 1.6; lineHeight: 47"
    position="1.1 -0.05 0"></a-entity>
</a-entity>

    

<a-entity
  id="modeviewer2d"
  class="modeItem"
  data-mode="classic"
  data-name="viewer2d"
  position="0 0 0"
  mixin="modeAnimations">
  <a-entity
    class="modeBackground"
    bind-toggle__raycastable="menuActive && !hasVR"
    position="0 0 -0.01"
    geometry="primitive: plane; width: 3; height: 0.8"
    material="shader: panelShader; brightness: 0.1; ratio: 4; borderWidth: 0.002"
    mixin="modeBackgroundHover modeBackgroundSelect"></a-entity>
  <a-entity
    class="modeTitle"
    mixin="font"
    text="align: left; value: VIEWER\nMODE; lineHeight: 45; width: 2.6"
    render-order="menutext"
    position="0.14 0.05 0"></a-entity>
  <a-entity
    class="modeThumb"
    mixin="modeThumbAnimations"
    geometry="primitive: plane; width: 0.7; height: 0.5"
    material="src: #modeViewerImg; shader: flat"
    position="-0.20 0 0"></a-entity>
  <a-entity
    class="modeInstructions"
    mixin="font"
    render-order="menutext"
    bind__text="color: colorPrimary"
    text="value: View the beat map.

Connect a VR headset
with controllers
to experience
more modes!; width: 1.6; lineHeight: 47"
    position="1.1 -0.05 0"></a-entity>
</a-entity>

  </a-entity>

  <a-entity id="modeVR" bind__visible="hasVR">
    

<a-entity
  id="modepunchvr"
  class="modeItem"
  data-mode="punch"
  data-name="punchvr"
  position="0 0.75 0"
  mixin="modeAnimations">
  <a-entity
    class="modeBackground"
    bind-toggle__raycastable="menuActive && hasVR"
    position="0 0 -0.01"
    geometry="primitive: plane; width: 3; height: 0.8"
    material="shader: panelShader; brightness: 0.1; ratio: 4; borderWidth: 0.002"
    mixin="modeBackgroundHover modeBackgroundSelect"></a-entity>
  <a-entity
    class="modeTitle"
    mixin="font"
    text="align: left; value: PUNCH\nMODE; lineHeight: 45; width: 2.6"
    render-order="menutext"
    position="0.14 0.05 0"></a-entity>
  <a-entity
    class="modeThumb"
    mixin="modeThumbAnimations"
    geometry="primitive: plane; width: 0.7; height: 0.5"
    material="src: #modePunchImg; shader: flat"
    position="-0.20 0 0"></a-entity>
  <a-entity
    class="modeInstructions"
    mixin="font"
    render-order="menutext"
    bind__text="color: colorPrimary"
    text="value: Punch the beats, mind
color.

Avoid all things yellow.

Punch harder
 for better score.; width: 1.6; lineHeight: 47"
    position="1.1 -0.05 0"></a-entity>
</a-entity>

    

<a-entity
  id="moderidevr"
  class="modeItem"
  data-mode="ride"
  data-name="ridevr"
  position="0 0 0"
  mixin="modeAnimations">
  <a-entity
    class="modeBackground"
    bind-toggle__raycastable="menuActive && hasVR"
    position="0 0 -0.01"
    geometry="primitive: plane; width: 3; height: 0.8"
    material="shader: panelShader; brightness: 0.1; ratio: 4; borderWidth: 0.002"
    mixin="modeBackgroundHover modeBackgroundSelect"></a-entity>
  <a-entity
    class="modeTitle"
    mixin="font"
    text="align: left; value: RIDE\nMODE; lineHeight: 45; width: 2.6"
    render-order="menutext"
    position="0.14 0.05 0"></a-entity>
  <a-entity
    class="modeThumb"
    mixin="modeThumbAnimations"
    geometry="primitive: plane; width: 0.7; height: 0.5"
    material="src: #modeRideImg; shader: flat"
    position="-0.20 0 0"></a-entity>
  <a-entity
    class="modeInstructions"
    mixin="font"
    render-order="menutext"
    bind__text="color: colorPrimary"
    text="value: Relax and enjoy the ride.

Take a quick breather.

No score!; width: 1.6; lineHeight: 47"
    position="1.1 -0.05 0"></a-entity>
</a-entity>

    

<a-entity
  id="modeclassicvr"
  class="modeItem"
  data-mode="classic"
  data-name="classicvr"
  position="0 -0.75 0"
  mixin="modeAnimations">
  <a-entity
    class="modeBackground"
    bind-toggle__raycastable="menuActive && hasVR"
    position="0 0 -0.01"
    geometry="primitive: plane; width: 3; height: 0.8"
    material="shader: panelShader; brightness: 0.1; ratio: 4; borderWidth: 0.002"
    mixin="modeBackgroundHover modeBackgroundSelect"></a-entity>
  <a-entity
    class="modeTitle"
    mixin="font"
    text="align: left; value: CLASSIC\nMODE; lineHeight: 45; width: 2.6"
    render-order="menutext"
    position="0.14 0.05 0"></a-entity>
  <a-entity
    class="modeThumb"
    mixin="modeThumbAnimations"
    geometry="primitive: plane; width: 0.7; height: 0.5"
    material="src: #modeClassicImg; shader: flat"
    position="-0.20 0 0"></a-entity>
  <a-entity
    class="modeInstructions"
    mixin="font"
    render-order="menutext"
    bind__text="color: colorPrimary"
    text="value: Cut the beats, mind
color and direction.

Avoid all things yellow.

Swing fast and accurate
for better score.; width: 1.6; lineHeight: 47"
    position="1.1 -0.05 0"></a-entity>
</a-entity>

  </a-entity>

  <a-entity
    id="loadingTipsContainer"
    bind__visible="menuActive"
    position="0 -1.3 0.1"
    rotation="0 0 0">

    <a-entity
      id="loadingTipsBackground"
      bind-toggle__raycastable="menuActive"
      render-order="menu"
      geometry="primitive: plane; width: 1.5; height: 0.3"
      material="shader: panelShader; ratio: 1.15; borderRadius: 0.4"
      render-order="menubutton"
      position="0 0 -0.03"></a-entity>

    <a-entity
      id="loadingTipsText"
      mixin="font"
      bind__text="color: colorPrimary"
      text="align: center; wrapCount: 30; width: 1; value: Press down on thumbstick center to open menu while playing."
      render-order="menutext"
      position="0 -0.02 0.001"></a-entity>
  </a-entity>
</a-entity>
<!-- </require> --></require>
  <!-- <require path="/home/lpv/repos/moonrider/src/templates/victory.html"> -->
<!-- Victory. -->
<a-entity
  id="victoryInfoContainer"
  position="0 1.5 -2"
  bind__visible="isVictory">

  <a-entity
    id="victoryAccuracyRing"
    bind__material="color: colorPrimary"k
    bind__victory-accuracy-ring="accuracy: score.finalAccuracy"
    animation="property: components.material.material.uniforms.progress.value; from: 0; easing: easeOutQuad; delay: 500; dur: 2500; autoplay: false"
    geometry="primitive: plane; width: 0.7; height: 0.7"
    material="shader: ring; transparent: true; radiusInner: 0.8; blending: additive; depthWrite: false"
    position="0 0.18 0"
    render-order="victory"></a-entity>

  <a-entity
    id="victoryInfoRank"
    class="accuracyTextCounterSubscribe"
    bind__animation="enabled: isVictory"
    bind__victory-rank="isVictory: isVictory; rank: score.rank"
    bind-toggle__raycastable="isVictory"
    scale="0 0 0"
    position="0 -0.034 0"
    animation__rotation="property: object3D.rotation.y; from: 0; to: -360; loop: true; easing: linear; dur: 5000; startEvents: textcounterdone"
    animation__scale="property: scale; from: 0 0 0; to: 1 1 1; loop: false; easing: easeOutQuad; dur: 300; startEvents: textcounterdone"
    play-sound="sound: #victorySound; event: textcounterdone"
    render-order="menuitemtext"
    text-geometry="font: #VigaRegularThree; bevelEnabled: true; bevelSize: 0.01; bevelThickness: 0.01; curveSegments: 7; height: 0.15; size: 0.4"></a-entity>

  <a-entity
    id="victoryInfoAccuracy"
    class="accuracyTextCounterSubscribe"
    mixin="font"
    bind__text="color: colorSecondary; opacity: isVictory && 0 || 0; value: score.score + ' POINTS'"
    animation="property: components.text.material.uniforms.opacity.value; from: 0; to: 1; startEvents: textcounterdone"
    text="align: left; wrapCount: 22; baseline: top; width: 0.81"
    position="0.85 0.2 0"
    render-order="menuitemtext"></a-entity>

  <a-entity
    id="victoryInfoBeatsHit"
    class="accuracyTextCounterSubscribe"
    mixin="font"
    bind__text="color: colorSecondary; opacity: isVictory && 0 || 0; value: score.beatsText"
    animation="property: components.text.material.uniforms.opacity.value; from: 0; to: 1; startEvents: textcounterdone"
    text="align: left; wrapCount: 22; baseline: top; width: 0.81"
    position="0.85 0.1 0"
    render-order="menuitemtext"></a-entity>

  <a-entity
    id="victoryInfoAccuracy"
    mixin="font"
    bind__text="color: colorTertiary"
    text="value: 0; align: center; wrapCount: 15; baseline: top; width: 2.25"
    bind__text-counter="enabled: isVictory; value: score.finalAccuracy"
    text-counter="suffix: %"
    position="0 -0.47 0"
    render-order="menuitemtext"></a-entity>

  <a-entity
    id="victoryInfoMaxCombo"
    mixin="font"
    bind__text="color: colorSecondary"
    bind__text-counter="enabled: isVictory; value: score.maxCombo"
    text="align: center; wrapCount: 22; baseline: top; width: 1"
    text-counter="prefix: MAX STREAK: ; emit: true"
    proxy-event="event: textcounterdone; to: .accuracyTextCounterSubscribe"
    position="0 -0.58 0"
    render-order="menuitemtext"></a-entity>

  <a-entity
    id="victoryButtons"
    play-sound="event: mouseenter; sound: #hoverSound; volume: 0.03"
    play-sound__click="event: click; sound: #confirmSound; volume: 0.25"
    render-order="menubutton">
    <a-entity
      id="victoryRestartButton"
      class="accuracyTextCounterSubscribe"
      mixin="gameMenuButton"
      bind-toggle__raycastable="isVictory"
      bind__material="opacity: isVictory && 0 || 0"
      animation="property: components.material.material.uniforms.opacity.value; from: 0; to: 1; startEvents: textcounterdone"
      position="-0.56 -0.79 0.05"
      proxy-event="event: click; to: a-scene; as: gamemenurestart">
      <a-entity
        class="accuracyTextCounterSubscribe"
        mixin="gameMenuButtonText"
        bind__text="opacity: isVictory && 0 || 0"
        animation="property: components.text.material.uniforms.opacity.value; from: 0; to: 1; startEvents: textcounterdone"
        render-order="menuitemtext"
        text="opacity: 0; value: PLAY AGAIN"></a-entity>
    </a-entity>

    <a-entity
      id="victoryExitButton"
      class="accuracyTextCounterSubscribe"
      mixin="gameMenuButton"
      bind-toggle__raycastable="isVictory"
      bind__material="opacity: isVictory && 0 || 0"
      animation="property: components.material.material.uniforms.opacity.value; from: 0; to: 1; startEvents: textcounterdone"
      position="0.56 -0.79 0.05"
      proxy-event="event: click; to: a-scene; as: gamemenuexit">
      <a-entity
        class="accuracyTextCounterSubscribe"
        mixin="gameMenuButtonText"
        bind__text="opacity: isVictory && 0 || 0"
        animation="property: components.text.material.uniforms.opacity.value; from: 0; to: 1; startEvents: textcounterdone"
        render-order="menuitemtext"
        text="opacity: 0; value: BACK TO MENU"></a-entity>
    </a-entity>
  </a-entity>
</a-entity>
<!-- </require> --></require>
  <!-- <require path="/home/lpv/repos/moonrider/src/templates/leaderboard.html"> -->
<a-entity
  id="leaderboard"
  class="accuracyTextCounterSubscribe"
  bind__animation="enabled: isVictory"
  bind__scale="isVictory && '0 0 0' || '1 1 1'"
  bind__visible="(!!menuSelectedChallenge.id || !!challenge.id) && (menuActive || isPaused || isVictory || isLoading) && !genreMenuOpen && gameMode !== 'ride'"
  position="2.36 1.5 -1.19"
  rotation="0 -60 0"
  animation="property: scale; from: 0 0 0; to: 1 1 1; easing: easeOutBack; startEvents: textcounterdone"
  render-order="menuitem">

  <a-entity
    bind-toggle__raycastable="leaderboardActive"
    id="leaderboardBackground" position="0 0 0"
    geometry="primitive: plane; width: 2; height: 2"
    material="shader: panelShader; ratio: 1.16; brightness: 0.2"></a-entity>

  <a-entity
    id="leaderboardChallengeImage"
    bind__menu-selected-challenge-image="coverURL: menuSelectedChallenge.coverURL"
    bind__visible="!isVictory"
    geometry="primitive: plane; height: 0.12; width: 0.12"
    material="shader: flat"
    position="-0.44 0.63 0.001"></a-entity>

  <a-entity
    id="leaderboardTitle"
    mixin="font"
    text="align: center; width: 2.5; value: LEADERBOARD"
    position="0.05 0.55 0.001"
    bind__visible="!leaderboardQualified"></a-entity>

  <a-entity
    id="leaderboardNames"
    mixin="font"
    bind__text="color: colorSecondary; value: leaderboardNames"
    bind__visible="!leaderboardQualified && !leaderboardEmpty"
    text="baseline: top; width: 1.2; anchor: left; wrapCount: 28; lineHeight: 53;"
    position="-0.7 0.3 0.001"></a-entity>

  <a-entity
    id="leaderboardScores"
    mixin="font"
    bind__text="value: leaderboardScores"
    bind__visible="!leaderboardQualified && !leaderboardEmpty"
    text="baseline: top; align: right; width: 1.2; anchor: right; color: #fff; wrapCount: 28; lineHeight: 53;"
    position="0.7 0.3 0.001"></a-entity>

  <a-entity
    id="leaderboardEmpty"
    mixin="font"
    bind__visible="leaderboard.length === 0 && !leaderboardQualified && !leaderboardLoading"
    text="align: center; color: #999; baseline: center; width: 2; value: No high scores. Be the first!"
    position="0 0 0.001"></a-entity>

  <a-entity
    id="leaderboardKeyboard"
    bind__super-keyboard="hand: activeHand === 'left' && '#leftHand' || '#rightHand'; show: leaderboardQualified"
    super-keyboard="inputColor: #fff; hand: #rightHand; imagePath: assets/img/keyboard; font: assets/fonts/Viga-Regular.json; align: center; model: superkeyboard; keyColor: #fff; injectToRaycasterObjects: false; filters: allupper; keyHoverColor: #fff; maxLength: 15; width: 1.5; label: NEW HIGH SCORE!\nENTER THE LEADERBOARD; labelColor: #FAFAFA"
    position="0 -0.08 0.02"
    proxy-event__change="event: superkeyboardchange; to: a-scene; as: leaderboardusername"
    keyboard-raycastable="condition: leaderboardQualified"
    render-order="menutext"
    render-order-recursive>
  </a-entity>

  <a-entity id="leaderboardSubmit"
    position="0 -0.67 0.002"
    mixin="bigMenuButton"
    bind__visible-raycastable="leaderboardQualified"
    proxy-event="event: click; to: a-scene; as: leaderboardsubmit">
      <a-entity mixin="font" text="align: center; color: #FFF; wrapCount: 26; value: SUBMIT HIGH SCORE" position="0 -0.055 0.01"></a-entity>
    <!--slice9="width: 1.5; height: 0.24"-->
  </a-entity>
</a-entity>
<!-- </require> --></require>
  <!-- <require path="/home/lpv/repos/moonrider/src/templates/news.html"> -->








<a-entity
  id="news"
  bind__visible="menuActive && !menuSelectedChallenge.id && !isMenuOpening"
  position="2.365374194652176 1.6 -1.1952715561051024"
  rotation="0 -60 0"
  render-order="menuitem">

  <a-entity
    id="newsBackground"
    bind-toggle__raycastable="menuActive && !menuSelectedChallenge.id && !isMenuOpening"
    geometry="primitive: plane; width: 2.1; height: 1.9"
    material="shader: panelShader; ratio: 1.14; brightness: 0.2"></a-entity>

  <a-entity
    id="newsText"
    mixin="font"
    text="align: left; color: #FAFAFA; baseline: center; width: 1.6; wrapCount: 50; value: Moon Rider (v2.9)

Open source demonstration codebase of a VR app built in HTML and JavaScript running on the Web.

A side project built by two people in a few months as a resource for A-Frame developers. Not meant to be an official, paid, nor fully released product.

Song maps sourced from beatsaver.com. Supports most browsers and headsets (including Quest).

This game was meant to serve as an example of a VR app running inside a webpage to help progress the open WebXR initiative (bsaber.com/moonrider).

Chat with us on moonrider.xyz/discord"
    position="0 -0.04 0.001"></a-entity>
</a-entity>

<a-entity
  id="support"
  bind__visible="menuActive && !menuSelectedChallenge.id && !isMenuOpening && inVR"
  position="2.365374194652176 0.25 -1.1952715561051024"
  rotation="-15 -60 0"
  render-order="menuitem">

  <a-entity
    id="supportBackground"
    bind-toggle__raycastable="menuActive && !menuSelectedChallenge.id && !isMenuOpening"
    geometry="primitive: plane; width: 2.1; height: 0.9"
    material="shader: panelShader; ratio: 1.14; brightness: 0.2"></a-entity>

  <a-entity
    id="supportImage"
    geometry="primitive: plane; width: 0.6; height: 0.5"
    material="shader: flat; src: /assets/img/banner.jpg"
    position="-0.5 0 0.001"></a-entity>

  <a-entity
    id="supportText"
    mixin="font"
    text="align: left; color: #FAFAFA; baseline: center; width: 1; wrapCount: 30; value: Support Moon Rider's hosting and development by purchasing Supermedium. The VR Comic Book Reader for Oculus Quest.\nA new way to experience comics, in vivid grand scale and comfort.\n\nFree demo available at supermedium.com"
    position="0.35 -0.04 0.001"></a-entity>
</a-entity>
<!-- </require> --></require>

  <a-mixin
    id="cursorMesh"
    material="shader: flat; transparent: true; src: #cursorMeshImg; depthTest: false"
    sub-object="from: #cursorLaser; name: glow"></a-mixin>

  <a-entity
    id="curve"
    material="shader: supercurve"
    supercurve
    supercurve-color
    render-order="curve"></a-entity>

  <a-entity
    id="tunnelsContainer"
    render-order="curve"
    bind__visible="isPlaying || isPaused"></a-entity>

  <a-entity
    id="beatContainer"
    beat-hit-sound
    bind__visible="isPlaying"></a-entity>

  <a-entity
    id="wallContainer"
    bind__visible="isPlaying"></a-entity>

  <a-entity id="curveFollowRig"
    bind__curve-follow-rig-reset="isVictory: isVictory"
    bind__supercurve-follow="enabled: isPlaying; speed: speed"
    supercurve-follow="target: #curve">

    <!-- <require path="/home/lpv/repos/moonrider/src/templates/stageFollow.html"> -->
<a-entity
  id="tube"
  bind__visible="isPlaying"
  rotation="90 180 0"
  position="0 0 -5"
  geometry="primitive: cylinder; radius: 3; openEnded: true; height: 20"
  materials="name: tube"
  animation="property: components.materials.material.uniforms.opacity.value; from: 1; to: 0; easing: easeInOutCubic; startEvents: pulse"></a-entity>

<a-entity
  id="platformShadow"
  obj-model="obj: #homeShadowObj"
  position="0 0.02 0"
  material="src: #homeShadowImg; shader: flat; blending: multiply; transparent: true;"
  raycastable-game
  render-order="curveshadow"
  stepback></a-entity>

<a-entity
  id="platform"
  obj-model="obj: #homeObj"
  materials="name: home"
  bind__materials="animate: isPlaying"></a-entity>

<a-entity
  id="sideGlows"
  bind__visible="isPlaying || isPaused">
  <a-entity
    id="leftSideGlow"
    geometry="primitive: plane; width: 8; height: 2"
    materials="name: leftsideglow"
    position="-2.1 .5 -3"
    rotation="20 -90 0"
    render-order="sideglow">
  </a-entity>
  <a-entity
    id="rightSideGlow"
    geometry="primitive: plane; width: 8; height: 2"
    materials="name: rightsideglow"
    position="2.1 .5 -3"
    rotation="-20 -90 0"
    render-order="sideglow">
  </a-entity>
</a-entity>

<a-entity
  id="light"
  light="type: hemisphere; color: #666"
  position="0 10 20"></a-entity>


<!-- </require> --></require>
    <!-- <require path="/home/lpv/repos/moonrider/src/templates/score.html"> -->
<a-mixin
  id="scoreText"
  mixin="font"
  text="lineHeight: 40; color: #FAFAFA; letterSpacing: -2; align: center; opacity: 0.7"></a-mixin>

<a-entity
  id="scoreContainer"
  bind__score-texts="isLoading: isLoading"
  bind__visible="score.active"
  render-order="score">

  <a-entity
    id="songProgressRing"
    bind__material="color: colorSecondary"
    bind__song-progress-info="enabled: isPlaying || isPaused && challenge.isBeatsPreloaded"
    geometry="primitive: plane; width: 0.57; height: 0.03"
    material="shader: flat"
    position="1.525 0.1 -3.94"
    rotation="-30 0 0">
  </a-entity>

  <a-entity id="scoreNumberContainer" position="1.5 0.13 -4">
    <a-entity
      id="combo"
      mixin="scoreText"
      bind__text="color: colorPrimary; value: 'STREAK  ' + score.combo"
      text="width: 3.5; align: left; anchor: left"
      rotation="-20 0 0"
      position="-0.025 0.175 0"></a-entity>

    <a-entity
      id="accuracy"
      mixin="scoreText"
      bind__text="color: colorSecondary; value: score.accuracyInt + '%' + ' / ' + score.score"
      text="width: 3.5; align: left; anchor: left"
      rotation="-20 0 0"></a-entity>
  </a-entity>
</a-entity>
<!-- </require> --></require>
    <!-- <require path="/home/lpv/repos/moonrider/src/templates/gameMenu.html"> -->
<a-mixin
  id="gameMenuButton"
  mixin="bigMenuButton"
  animation__mouseenter="property: components.material.material.uniforms.activePanel.value; from: 0; to: 1; startEvents: mouseenter; pauseEvents: mouseleave; dur: 70"
  animation__mouseleave="property: components.material.material.uniforms.activePanel.value; from: 1; to: 0; startEvents: mouseleave; pauseEvents: mouseenter; dur: 70"
  geometry="height: 0.28"></a-mixin>

<a-mixin
  id="gameMenuButtonText"
  mixin="font"
  position="0 -0.08 0.01"
  render-order="menutext"
  text="align: center; wrapCount: 17"></a-mixin>

<!-- Titles. -->
<a-entity id="inGameMenuTitles" position="0 2.2 -2.3">
  <a-entity mixin="gameMenuButtonText" text="value: GAME OVER; color: #f01978; width: 3.5" bind__visible="isGameOver"></a-entity>
  <a-entity mixin="gameMenuButtonText" text="value: SONG CLEARED; color: #FFF; width: 3.5" bind__visible="isVictory" position="0 0.1 0"></a-entity>
  <a-entity mixin="gameMenuButtonText" bind__text="color: colorPrimary" text="value: PAUSED; width: 3.5" bind__visible="isPaused"></a-entity>
</a-entity>

<a-entity
  id="gameMenu"
  bind__visible="isPaused || isVictory"
  position="0 1.5 -2"
  play-sound="event: mouseenter; sound: #hoverSound; volume: 0.1"
  play-sound__click="event: click; sound: #confirmSound; volume: 0.25">

  <!-- Actions. -->
  <a-entity
    id="resumeButton"
    mixin="gameMenuButton"
    bind-toggle__raycastable="isPaused"
    bind__visible="isPaused"
    position="0 0.35 0"
    proxy-event="event: click; to: a-scene; as: gamemenuresume">
    <a-entity mixin="gameMenuButtonText" text="value: RESUME"></a-entity>
  </a-entity>

  <a-entity
    id="restartButton"
    mixin="gameMenuButton"
    bind__visible="!isVictory"
    bind-toggle__raycastable="isPaused || isGameOver"
    proxy-event="event: click; to: a-scene; as: gamemenurestart">
    <a-entity mixin="gameMenuButtonText" text="value: RESTART SONG"></a-entity>
  </a-entity>

  <a-entity
    id="exitButton"
    mixin="gameMenuButton"
    bind__visible="!isVictory"
    bind-toggle__raycastable="isPaused || isGameOver"
    position="0 -0.35 0"
    proxy-event="event: click; to: a-scene; as: gamemenuexit">
    <a-entity mixin="gameMenuButtonText" text="value: EXIT TO MENU"></a-entity>
  </a-entity>

  <!-- Song info. -->
  <a-entity id="gameMenuSongInfoContainer"
    position="0 -1 0.15473"
    rotation="-20 0 0"
    song-info-positioner
    bind__song-info-positioner="victory: isVictory">
    <a-entity id="gameMenuSongBackground"
      bind-toggle__raycastable="isPaused || isVictory"
      render-order="menu"
      geometry="primitive: plane; width: 2.5; height: 0.3"
      material="shader: panelShader; transparent: true; ratio: 4; borderRadius: 0.5; borderWidth: 0.02"
      position="0 0 -0.03"></a-entity>

    <a-entity id="gameMenuSongImage"
      copy-texture="from: #menuSelectedChallengeImage"
      geometry="primitive: plane; buffer: false; skipCache: true; height: 0.3; width: 0.3"
      material="shader: flat"
      position="-1 0 0"></a-entity>

    <a-entity id="gameMenuSongInfo">
      <a-entity
        id="gameMenuSongName"
        position="0 0.01 0"
        mixin="font" text="align: center; color: #fff; wrapCount: 30; baseline: top; lineHeight: 36; width: 1.2"
        bind__text="value: challenge.metadata.songName"></a-entity>
      <a-entity
        id="gameMenuSongSubName"
        mixin="font"
        position="0 -0.09 0"
        bind__text="color: colorSecondary"
        bind__text-truncate="value: challenge.metadata.songSubName + ' - ' + challenge.metadata.songAuthorName"
        text-truncate="length: 80"
        text="wrapCount: 80; align: center; width: 2.4" bind__text="value: menuSelectedChallenge.songSubName"></a-entity>
    </a-entity>
  </a-entity>
</a-entity>
<!-- </require> --></require>

    <!-- Beat pieces, explosions, fx, and weapon trail. -->
    <a-entity id="rigContainer"></a-entity>

    <!-- Supercut FX rings. -->
    
      <a-entity class="superCutFx" mixin="superCut"></a-entity>
    
      <a-entity class="superCutFx" mixin="superCut"></a-entity>
    
      <a-entity class="superCutFx" mixin="superCut"></a-entity>
    
      <a-entity class="superCutFx" mixin="superCut"></a-entity>
    

    <!-- Player. -->
    <a-entity id="cameraRig">
      <a-entity
        id="camera"
        bind__wasd-controls="enabled: !inVr"
        position="0 1.6 0.5"
        camera="far: 10000"
        look-controls
        player-height
        wasd-controls="acceleration: 15"></a-entity>
      <a-entity
        id="cameraWallCollider"
        bind__raycaster__wall="enabled: isPlaying && gameMode !== 'ride'"
        proxy-event__wallhitstart="event: raycaster-intersection; to: a-scene; as: wallhitstart"
        proxy-event__wallhitend="event: raycaster-intersection-cleared; to: a-scene; as: wallhitend"
        follow-position="target: #camera"
        raycaster__wall="objects: [data-wall-active]; interval: 150; direction: 0 -1 0; far: 5"
        visible="false"></a-entity>
    </a-entity>

    <a-entity
      id="controllerRig"
      proxy-event="event: recentered; to: #cameraRig; captureBubbles: true; as: recenter">
      

      
        <a-entity id="leftHand"
          class="weapon"
          bind__hand-swapper="enabled: rightRaycasterActive"
          bind__haptics-wall="enabled: isPlaying && gameMode === 'classic'"
          bind__headfist="isPlaying: isPlaying"
          bind__menu-controls="enabled: mainMenuActive"
          bind__pauser="enabled: isPlaying"
          bind__punch="enabled: isPlaying && gameMode === 'punch'"
          bind__raycaster="enabled: leftRaycasterActive"
          bind__raycaster__game="enabled: isPlaying && (gameMode === 'classic' || gameMode === 'punch')"
          bind__blade="enabled: isPlaying && gameMode === 'classic'"
          bind__weapon-particles="enabled: isPlaying; gameMode: gameMode"
          bind__trail="colorScheme: colorScheme; enabled: isPlaying && gameMode === 'classic'"
          controller="hand: left"
          data-hand="left"
          haptics="events: mouseenter; dur: 35; force: 0.075"
          haptics__beat="events: beathaptic; dur: 90; force: 0.55"
          haptics__draw="events: drawblade; dur: 750; force: 0.025"
          haptics__plume="events: plumepulse; dur: 35; force: 0.1"
          headfist="hand: left"
          raycaster="objects: [raycastable]; far: 5; showLine: false"
          raycaster__game="objects: [raycastable-game]; far: 1; interval: 71; direction: 0 1 -1"
          weapon="hand: left"
          weapon-particles="hand: left"
          thumb-controls
          thumb-controls-debug="enabled: false; hand: left; controllerType: vive-controls"
          render-order="weapon"
          trail="color: primary; hand: left">
          <a-entity bind__position="has3DOFVR && '0 0 -0.5' || '0 0 0'">
            <a-entity
              id="leftLaser"
              class="laser"
              bind__material="color: colorPrimary"
              bind__cursor-laser="enabled: activeHand === 'left' && !isPlaying"
              geometry="primitive: cylinder; height: 1; radius: 0.005"
              material="shader: flat; opacity: 0.25; transparent: true"
              rotation="-90 0 0"></a-entity>
          </a-entity>

          <!-- Blade. -->
          <a-entity bind__position="has3DOFVR && '0 0 -0.5' || '0 0 0'"
                    bind__rotation="controllerType.indexOf('oculus') !== -1 && '135 0 0' || '90 0 0'">
            <a-entity
              class="bladeContainer"
              bind__visible="isPlaying && gameMode === 'classic'"
              animation="property: scale; from: 0 0 0; to: 1 1 1; dur: 750; easing: linear; startEvents: drawblade"
              scale="0.001 0.001 0.001">
              <a-entity
                class="blade bladeleft"
                obj-model="obj: #weaponObj"
                materials="name: leftWeapon"
                render-order="weapon"
                position="0 -0.43 0">
                <a-entity class="bladeTipHelper" position="0 -0.45 0"></a-entity>
              </a-entity>
            </a-entity>

            <a-entity
              class="bladeHandle"
              bind__visible="!isPlaying || gameMode === 'classic'"
              obj-model="obj: #weaponHandleObj"
              materials="name: leftWeaponHandle">
              <a-entity class="bladeHandleHelper"></a-entity>
            </a-entity>
          </a-entity>

          <!-- Punch. -->
          <a-entity
            id="leftpunch"
            class="punch"
            render-order="weapon"
            bind__visible="isPlaying && gameMode === 'punch'"
            bind__position="has3DOFVR && '0 0 -0.75' || '0 0 0'"
            rotation="0 0 0">
              <a-entity
                class="punchFist"
                obj-model="obj: #leftFistObj"
                materials="name: leftFist"></a-entity>
              <a-entity
                class="punchBbox"
                geometry="primitive: box; width: 0.2; height: 0.23; depth: 0.15"
                material="shader: flat; opacity: 0.5"
                position="0 0.05 0.1"
                rotation="30 0 0"
                visible="false"></a-entity>
              <a-entity
                obj-model="obj: #leftFistWeaponObj"
                materials="name: leftFistWeapon"></a-entity>
          </a-entity>

          <!-- Ride. -->
          <a-entity
            id="leftstar"
            class="handStar"
            render-order="weapon"
            bind__visible="isPlaying && gameMode === 'ride'">
              <a-entity
                class="handStar"
                bind__material="colorPrimary: colorPrimary; colorSecondary: colorSecondary; colorTertiary: colorTertiary"
                geometry="primitive: sphere; radius: 0.1"
                material="shader: handStar"
                animation__pulse="property: components.material.material.uniforms.pulse.value; from: 2; to: 0; dur: 300; startEvents: plumepulse; easing: easeInOutQuad"
                animation__scale="property: scale; from: 2 2 2; to: 1 1 1; dur: 1200; startEvents: plumepulse; easing: easeInOutQuad"></a-entity>
          </a-entity>
        </a-entity>

        <a-entity
          id="leftCursorMesh"
          mixin="cursorMesh"
          bind__cursor-mesh="active: leftRaycasterActive && !isPlaying"
          bind__material="color: colorPrimary"
          cursor-mesh="cursorEl: #leftHand"
          material
          render-order="cursor"
          scale="1.3 1.3 1.3"></a-entity>
      
      
        <a-entity id="rightHand"
          class="weapon"
          bind__hand-swapper="enabled: leftRaycasterActive"
          bind__haptics-wall="enabled: isPlaying && gameMode === 'classic'"
          bind__headfist="isPlaying: isPlaying"
          bind__menu-controls="enabled: mainMenuActive"
          bind__pauser="enabled: isPlaying"
          bind__punch="enabled: isPlaying && gameMode === 'punch'"
          bind__raycaster="enabled: rightRaycasterActive"
          bind__raycaster__game="enabled: isPlaying && (gameMode === 'classic' || gameMode === 'punch')"
          bind__blade="enabled: isPlaying && gameMode === 'classic'"
          bind__weapon-particles="enabled: isPlaying; gameMode: gameMode"
          bind__trail="colorScheme: colorScheme; enabled: isPlaying && gameMode === 'classic'"
          controller="hand: right"
          data-hand="right"
          haptics="events: mouseenter; dur: 35; force: 0.075"
          haptics__beat="events: beathaptic; dur: 90; force: 0.55"
          haptics__draw="events: drawblade; dur: 750; force: 0.025"
          haptics__plume="events: plumepulse; dur: 35; force: 0.1"
          headfist="hand: right"
          raycaster="objects: [raycastable]; far: 5; showLine: false"
          raycaster__game="objects: [raycastable-game]; far: 1; interval: 70; direction: 0 1 -1"
          weapon="hand: right"
          weapon-particles="hand: right"
          thumb-controls
          thumb-controls-debug="enabled: false; hand: right; controllerType: vive-controls"
          render-order="weapon"
          trail="color: secondary; hand: right">
          <a-entity bind__position="has3DOFVR && '0 0 -0.5' || '0 0 0'">
            <a-entity
              id="rightLaser"
              class="laser"
              bind__material="color: colorSecondary"
              bind__cursor-laser="enabled: activeHand === 'right' && !isPlaying"
              geometry="primitive: cylinder; height: 1; radius: 0.005"
              material="shader: flat; opacity: 0.25; transparent: true"
              rotation="-90 0 0"></a-entity>
          </a-entity>

          <!-- Blade. -->
          <a-entity bind__position="has3DOFVR && '0 0 -0.5' || '0 0 0'"
                    bind__rotation="controllerType.indexOf('oculus') !== -1 && '135 0 0' || '90 0 0'">
            <a-entity
              class="bladeContainer"
              bind__visible="isPlaying && gameMode === 'classic'"
              animation="property: scale; from: 0 0 0; to: 1 1 1; dur: 750; easing: linear; startEvents: drawblade"
              scale="0.001 0.001 0.001">
              <a-entity
                class="blade bladeright"
                obj-model="obj: #weaponObj"
                materials="name: rightWeapon"
                render-order="weapon"
                position="0 -0.43 0">
                <a-entity class="bladeTipHelper" position="0 -0.45 0"></a-entity>
              </a-entity>
            </a-entity>

            <a-entity
              class="bladeHandle"
              bind__visible="!isPlaying || gameMode === 'classic'"
              obj-model="obj: #weaponHandleObj"
              materials="name: rightWeaponHandle">
              <a-entity class="bladeHandleHelper"></a-entity>
            </a-entity>
          </a-entity>

          <!-- Punch. -->
          <a-entity
            id="rightpunch"
            class="punch"
            render-order="weapon"
            bind__visible="isPlaying && gameMode === 'punch'"
            bind__position="has3DOFVR && '0 0 -0.75' || '0 0 0'"
            rotation="0 0 0">
              <a-entity
                class="punchFist"
                obj-model="obj: #rightFistObj"
                materials="name: rightFist"></a-entity>
              <a-entity
                class="punchBbox"
                geometry="primitive: box; width: 0.2; height: 0.23; depth: 0.15"
                material="shader: flat; opacity: 0.5"
                position="0 0.05 0.1"
                rotation="30 0 0"
                visible="false"></a-entity>
              <a-entity
                obj-model="obj: #rightFistWeaponObj"
                materials="name: rightFistWeapon"></a-entity>
          </a-entity>

          <!-- Ride. -->
          <a-entity
            id="rightstar"
            class="handStar"
            render-order="weapon"
            bind__visible="isPlaying && gameMode === 'ride'">
              <a-entity
                class="handStar"
                bind__material="colorPrimary: colorPrimary; colorSecondary: colorSecondary; colorTertiary: colorTertiary"
                geometry="primitive: sphere; radius: 0.1"
                material="shader: handStar"
                animation__pulse="property: components.material.material.uniforms.pulse.value; from: 2; to: 0; dur: 300; startEvents: plumepulse; easing: easeInOutQuad"
                animation__scale="property: scale; from: 2 2 2; to: 1 1 1; dur: 1200; startEvents: plumepulse; easing: easeInOutQuad"></a-entity>
          </a-entity>
        </a-entity>

        <a-entity
          id="rightCursorMesh"
          mixin="cursorMesh"
          bind__cursor-mesh="active: rightRaycasterActive && !isPlaying"
          bind__material="color: colorSecondary"
          cursor-mesh="cursorEl: #rightHand"
          material
          render-order="cursor"
          scale="1.3 1.3 1.3"></a-entity>
      
    </a-entity>

    <a-entity
      id="stepback"
      position="0 1.6 -1.55"
      geometry="primitive: plane; width: 0.25; height: 0.25;"
      material="shader: flat; src: #stepbackImg; transparent: true; opacity: 0"
      render-order="stepback"></a-entity>
  </a-entity>

  <a-entity
    id="mouseCursor"
    bind__raycaster="enabled: !inVR"
    cursor="rayOrigin: mouse"
    raycaster="objects: [raycastable]"></a-entity>
  <a-entity
    id="mouseCursorMesh"
    mixin="cursorMesh"
    cursor-mesh="cursorEl: #mouseCursor"
    bind__cursor-mesh="active: menuActive"
    render-order="cursor"></a-entity>

  <a-entity
    tail="target: #leftstar"
    render-order="weapon"
    bind__visible="isPlaying && gameMode === 'ride'"></a-entity>
  <a-entity
    tail="target: #rightstar"
    render-order="weapon"
    bind__visible="isPlaying && gameMode === 'ride'"></a-entity>
</a-scene>
`;

// Initial inject HTML into document. Only run once.
document.addEventListener('DOMContentLoaded', append);

function append () {
  let container = document.getElementById('app');
  if (!container) {
    container = document.createElement('div');
    container.id = 'app';
    document.body.appendChild(container);
  }
  container.innerHTML = html;
}

if (module.hot) {
  const DiffDom = require('diff-dom').DiffDOM;

  module.hot.accept();

  // HTML changed, diff.
  if (module.hot.data && module.hot.data.oldHtml) {
    const oldHtml = module.hot.data.oldHtml;
    const diffdom = new DiffDom();

    const oldScene = document.createElement('div');
    oldScene.innerHTML = oldHtml;

    const newScene = document.createElement('div');
    newScene.innerHTML = html;

    const diff = diffdom.diff(oldScene.querySelector('a-scene'),
                              newScene.querySelector('a-scene'));
    diffdom.apply(document.querySelector('a-scene'), diff);
  }

  // Store HTML for next module to diff.
  module.hot.dispose(data => {
    data.oldHtml = html;
  });
}
